import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";

import { ClientSideRowModelModule } from "ag-grid-community";
import { ModuleRegistry } from "ag-grid-community";
import { useLocation, useNavigate } from "react-router-dom";
import PMRService from "../services/pmrservice";
import { useSelector, useDispatch } from "react-redux";
import { Receipts, AccountSettings } from "pageComponents";
import { toast } from 'react-toastify';
import { showPmrDeleteConfirm } from '../utils/swalUtils';
import UploadReports from '../pageComponents/uploadReport.js/uploadreportsclaud';
import MedicationsModal from "pageComponents/dialogs/dashboard/addMedication";
import ViewSharedReports from "pageComponents/user/accessReport/viewsharedreports";
import LiveChat from "pageComponents/userChat/userChat";
import ApplicationAnnouncement from 'components/ApplicationAnnouncement';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import BackButton from "components/backButton";
import Scheduler from "../pageComponents/user/scheduler/scheduler";
import {

    getMedicationatDashboard,
    getLabResultatDashboard,
    getVitals,
    getgridHeaders,
    getMRSitesReports,
    // getAllMRSItesReports,
    getLogUserMenuAnalytics, getProviderforAdvanceSearch, getHospitalsforAdvanceSearch, deleteReports, archiveReport, mrSitesReportsGetByReportID,
    getChatHistory, sendMessage, undoarchiveMRSItesReports, endChat,
    sendEmail,
    downloadMultipleReports,
    } from "apiServices/reducer/apiService";
import {
    SharedReports, Blog, BMIScreen, SecondOpinion, ShareReportDialog, MedicalCondition,
    ScheduleForChildren, ScheduleByAge, TrueContraindications, AdministeringVaccinesToAdults, ViewTrends, PatientSummaryDialog
} from "pageComponents";

//import { SharedReports, Blog, BMIScreen, SecondOpinion, VitalsMetabolicsModal, ConfirmationPopup, ShareReportDialog, UserChatIcon } from "pageComponents";

import { AddVitals, AdvanceSearch } from "pageComponents";
import { Dashbaord } from "pages";

import {
    Image as ImageIcon,
    Droplet,
    Heart,
    FileText,
} from 'lucide-react';
import { CTDropDownMulti, CTDatePickerRange, CTGrid, ReportDisplaySection, NoteApp, AskAcme, CustomSuccessModal } from "components";
import { EditReportDialog, AddNote, PasswordChangeModal, MultipleEmailDialog } from "pageComponents";
import { wrap } from "framer-motion";
import { tab } from "@testing-library/user-event/dist/tab";
import { getReportDownloadFilename, isNonPreviewableReportBlob } from '../utils/utils';

/** Milliseconds at local midnight; avoids Date.parse (MM/DD/YYYY differs in Firefox vs Chromium). */
function parseReportDateForSort(val) {
    if (val == null || val === '') return null;
    if (typeof val === 'number' && Number.isFinite(val)) return val;
    if (val instanceof Date && !Number.isNaN(val.getTime())) {
        return new Date(val.getFullYear(), val.getMonth(), val.getDate()).getTime();
    }
    const str = String(val).trim();
    if (!str || str === 'N/A') return null;

    const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
        const y = parseInt(iso[1], 10);
        const m = parseInt(iso[2], 10);
        const d = parseInt(iso[3], 10);
        if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d)) {
            const t = new Date(y, m - 1, d).getTime();
            return Number.isNaN(t) ? null : t;
        }
    }
    if (str.includes('/')) {
        const parts = str.split('/');
        if (parts.length >= 3) {
            const m = parseInt(parts[0], 10);
            const d = parseInt(parts[1], 10);
            const y = parseInt(parts[2], 10);
            if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d)) {
                const t = new Date(y, m - 1, d).getTime();
                return Number.isNaN(t) ? null : t;
            }
        }
    }
    return null;
}

function compareReportDates(valueA, valueB) {
    const a = parseReportDateForSort(valueA);
    const b = parseReportDateForSort(valueB);
    if (a === null && b === null) return 0;
    if (a === null) return 1;
    if (b === null) return -1;
    return a - b;
}

// Custom tooltip styles
const customTooltipStyles = `
    .custom-tooltip {
        background-color: #2c3e50 !important;
        color: white !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        border: none !important;
        max-width: 200px !important;
        text-align: center !important;
        opacity: 0.95 !important;
        transition: opacity 0.3s ease-in-out !important;
    }

    .custom-tooltip .tooltip-arrow {
        border-color: #2c3e50 !important;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.1);
            opacity: 0.8;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes blinkNotification {
        0% {
            opacity: 1;
            transform: scale(1);
        }
        25% {
            opacity: 0.3;
            transform: scale(0.95);
        }
        50% {
            opacity: 1;
            transform: scale(1.1);
        }
        75% {
            opacity: 0.3;
            transform: scale(0.95);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    .chat-notification-blink {
        box-shadow: 0 0 15px rgba(255, 0, 0, 0.6);
    }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = customTooltipStyles;
document.head.appendChild(styleSheet);

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const UserLandingPage = (props) => {
    console.log("UserLandingPage props.activeMenuItem:", props.activeMenuItem);
    const gridRef = useRef(null);
    const iframeRef = useRef(null);
    const previewContainerRef = useRef(null);
    const searchDebounceRef = useRef(null);
    const searchRequestIdRef = useRef(0);
    const searchWasActiveRef = useRef(false);
    const reportsGridLoadInflightRef = useRef(0);
    const reportsFetchIdRef = useRef(0);
    const reportPreviewRequestIdRef = useRef(0);
    const [activeTab, setActiveTab] = useState('All');
    const [searchQuery, setSearchQuery] = useState("");
    const [togglePDF, setTogglePDF] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [medicationModalMode, setMedicationModalMode] = useState('add');
    const dispatch = useDispatch()
    const token = useSelector((state) => state.apiService.token);
    const userData = useSelector((state) => state.apiService.login);
    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
    const [selectedRow, setSelectedRow] = useState(null);
    const isAccess = menuData.role === 'User';
    const [isProvider, setIsProvider] = useState(userData.user_type_name === 'Provider');
    useEffect(() => {
        if (!isAccess && userData) {
            setIsProvider(userData.user_type_name === 'Provider');
        } else {
            setIsProvider(false);
        }
    }, [isAccess, userData]);

    useEffect(() => {
        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
        };
    }, []);

    const params = {
        token: token,
        user_id: isProvider ? props.userID : (props.selectedFamilyMember ? props.selectedFamilyMember.user_id : userData?.user_id)
    };


    const [rowData, setRowData] = useState([]);
    const [rowDatanew, setRowDatanew] = useState([]);
    const [isSelectedBloodWork, setIsSelectedBloodWork] = useState(false);


    const [selectedCategories, setSelectedCategories] = useState([])
    const [selectedProviders, setSelectedProviders] = useState([]);
    const [selectedHospitals, setSelectedHospitals] = useState([]);

    const [showShareReportDialog, setShowShareReportDialog] = useState(false);
    const [showEditReportDialog, setShowEditReportDialog] = useState(false);
    const [groupsLst, setGroupsLst] = useState([]);
    const [showNotesDialog, setShowNotesDialog] = useState(false);
    const [showMultipleEmailDialog, setShowMultipleEmailDialog] = useState(false);
    const [includeArchivedforReports, setIncludeArchivedforReports] = useState(false);
    const [newMessage, setNewMessage] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [checkedReports, setCheckedReports] = useState({});
    const [bloodWorkChecked, setBloodWorkChecked] = useState(false);
    const [isCompare, setIsCompare] = useState(false);
    const [chatData, setChatData] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const fileInputRef = useRef(null);
    const recognitionRef = useRef(null);
    const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertFileName, setAlertFileName] = useState("");
    const [showDownloadSuccessModal, setShowDownloadSuccessModal] = useState(false);
    const [downloadAlertMessage, setDownloadAlertMessage] = useState("");
    const [downloadAlertFileName, setDownloadAlertFileName] = useState("");
    const [showBlink, setShowBlink] = useState(false);
    const [shouldRefetchAfterClear, setShouldRefetchAfterClear] = useState(false);
    const [isReportsGridLoading, setIsReportsGridLoading] = useState(false);
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false);
    const [contentType, setContentType] = useState(null);
    const [chatNotificationCount, setChatNotificationCount] = useState(0); // For red bubble notification
    const [showChatNotification, setShowChatNotification] = useState(false); // Control when to show notification

    const [reportData, setReportData] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    const [selectedReportName, setSelectedReportName] = useState(null);
    const [selectedReportID, setSelectedReportID] = useState();
    const emailDialogSelectedReports = useMemo(() => {
        const checkedIds = Object.entries(checkedReports)
            .filter(([, isChecked]) => isChecked)
            .map(([id]) => String(id));
        const fromChecked = rowData.filter(
            (r) => r?.reportId !== '' && r?.reportId != null && checkedIds.includes(String(r.reportId))
        );
        if (fromChecked.length > 0) {
            return fromChecked.map((r) => ({
                reportId: r.reportId,
                name: r.name || 'Untitled report',
                date: r.date,
                category: r.category,
                clinic: r.clinic,
            }));
        }
        if (selectedReportID != null && selectedReportID !== '') {
            const row = rowData.find((r) => String(r.reportId) === String(selectedReportID));
            if (row && row.reportId !== '') {
                return [{
                    reportId: row.reportId,
                    name: row.name || 'Untitled report',
                    date: row.date,
                    category: row.category,
                    clinic: row.clinic,
                }];
            }
            if (selectedReportName) {
                return [{ reportId: selectedReportID, name: selectedReportName }];
            }
        }
        return [];
    }, [checkedReports, rowData, selectedReportID, selectedReportName]);
    const [chatHistory, setChatHistory] = useState([]);
    const [showPatientSummaryDialog, setShowPatientSummaryDialog] = useState(false);
    const [editReportData, setEditReportData] = useState({
        ReportID: 63127,
        ReportName: "Laboratory Investigation Report",

        GroupID: 3,

        TagNo: null,

        ProviderName: "Dr.Firoz Pathan",

        HospitalName: "Kamineni Health Care Private Limited",

        UserID: 10129,

        ReportDate: "11/13/2024",

        LoginUserID: 10129

    });

    const [checkedReportIds, setCheckedReportIds] = useState([]);
    const [checkedReportsForCompare, setCheckedReportsForCompare] = useState([]);
    const [showBloodReportsAlert, setShowBloodReportsAlert] = useState(false);
    const [bloodReportsAlertMessage, setBloodReportsAlertMessage] = useState("Please select at least 2 blood reports to compare");

    // Separate state variables for different success modals
    const [showArchiveSuccessModal, setShowArchiveSuccessModal] = useState(false);
    const [showUnarchiveSuccessModal, setShowUnarchiveSuccessModal] = useState(false);

    // Flags to prevent double execution
    const [isArchiveProcessing, setIsArchiveProcessing] = useState(false);
    const [isUnarchiveProcessing, setIsUnarchiveProcessing] = useState(false);

    // Refs to track modal state
    const archiveModalShownRef = useRef(false);
    const unarchiveModalShownRef = useRef(false);

    // Tracks whether dashboard Lab Results have already been loaded for the current mount.
    // Prevents the multi-purpose dashboard effect from re-fetching Lab Results on unrelated
    // functionality/navigation changes (e.g. activeTab or analytics updates). Explicit
    // refreshes (Refresh button, upload success, family-member switch) bypass this guard.
    const dashboardLabResultsLoadedRef = useRef(false);

    const [userId, setUserId] = useState(isProvider ? props.userID : userData.user_id)

    const menuItems = [
        { label: 'Imaging', icon: <ImageIcon className="pmr-menu-icon" />, color: "#e0f2fe", id: 2, parent_id: 2, },
        { label: 'Blood work', icon: <Droplet className="pmr-menu-icon" />, color: "#e0f2fe", id: 3, parent_id: 2 },
        { label: 'Cardiology', icon: <Heart className="pmr-menu-icon" />, color: "#e0f2fe", id: 4, parent_id: 2 },
        { label: 'Prescriptions', icon: <FileText className="pmr-menu-icon" />, color: "#e0f2fe", id: 9, parent_id: 2 },
    ];


    const [gridHeaders, setGridHeaers] = useState([
        { name: 'All', id: 0 },
        { name: 'Imaging', id: 2 },
        { name: 'Blood work', id: 3 },
        { name: 'Cardiology', id: 4 },
        { name: 'Gastroenterology', id: 5 },
        { name: 'Neurology', id: 6 },
        { name: 'Prescriptions', id: 9 }
    ]);



    const [medications, setMedicationData] = useState([]);
    const [medicationLoading, setMedicationLoading] = useState(true);

    const [medication, setMedications] = useState([]);
    const [provider, setProvider] = useState([]);
    const [hospitals, setHospital] = useState([]);
    const [reportGroupNames, setReportGroupNames] = useState("");

    const [labResults, setLabResults] = useState([

    ]);
    const [labResultsLoading, setLabResultsLoading] = useState(true);
    // All provider notes/reports for HealthCare Calendar (every category, not only Blood work)
    const [calendarReports, setCalendarReports] = useState([]);
    // Raw vitals rows (with LastUpdated timestamps) used to render per-day health metrics on the HealthCare Calendar
    const [vitalsRaw, setVitalsRaw] = useState([]);
    // When a date is clicked on the calendar we stash it here and switch to the Reports view filtered to that day
    const [pendingReportDate, setPendingReportDate] = useState(null);
    // Provider note clicked on the calendar, opened in the preview pane once the grid has loaded
    const [pendingReportPreview, setPendingReportPreview] = useState(null);
    const handleAddClick = () => {
        setMedicationModalMode('add');
        setShowModal(true);
    };

    const handleEditClick = () => {
        setMedicationModalMode('edit');
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleSaveMedications = (updatedMedications) => {
        setMedications(updatedMedications);
        setMedicationData(updatedMedications);
        setShowModal(false);
    };






    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: reportGroupNames,
        ProviderName: '',
        HospitalName: '',
        user_id: userId,  // Changed from UserID to user_id
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: token,
        IncludeArchived: false
    });
    const [viewReportDataforArchived, setViewReportDataforArchived] = useState({
        ReportGroupName: reportGroupNames,
        ProviderName: '',
        HospitalName: '',
        user_id: userId,  // Changed from UserID to user_id
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: token,
        IncludeArchived: true
    });
    const [logUserMenuAnalyticsData, setLogUserMenuAnalyticsData] = useState({
        MenuID: 3,
        ParentID: 2,
        UserID: 5,
        token: token
    });
    const [deleteparams, setDeleteparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: token
    });
    const [archiveparams, setArchiveparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: token
    });
    const [bloodWorkSummary, setBloodWorkSummary] = useState("");

    const [pdfUrl, setPDFURL] = useState()
    const location = useLocation();
    const data = location.state?.data || {};
    const [showLiveChat, setShowLiveChat] = useState(false);
    const [showViewTrends, setShowViewTrends] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Add states for patient details view (similar to provider)
    const [isPatientDetailsView, setIsPatientDetailsView] = useState(false);
    const [selectedPatientName, setSelectedPatientName] = useState('');
    const [isFromDetails, setIsFromDetails] = useState(false);
    const [isFromReports, setIsFromReports] = useState(false);



    const [vitalsValues, setVitalsValues] = useState({
        BloodPressure: "",
        HeartRate: "",
        BloodSugar: "",
        Weight: "",
        WaistSize: "",
    });

    const handleSaveNotes = (newNote) => {
        console.log(newNote, "newNote")
    }
    const [chatParams, setChatParams] = useState({
        loginUserId: userId,
        senderId: userId,
        receiverId: 0,
        message: newMessage,
        token: token,
        chatId: 0,
        messageType: 1
    })

    const sendnewMessagewhileChat = () => {
        dispatch(sendMessage(chatParams)).then((resp) => {
            console.log(resp, "resp")
            if (resp.payload) {
                setChatHistory("");
                invokeChatHistory();
                setNewMessage('');

            }
        });
        // <-- Clear after sending
    }

    const medicationData = [{ medication: 'TEST', frequency: 1, },];
    const handleInputChange = (field, value) => {
        console.log(field, value, "field, value")
        setEditReportData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };
    const setNewMessagewhileChat = (e) => {
        console.log(e, "message in setNewMessagewhileChat")
        setNewMessage(e)
        setChatParams({
            ...chatParams,
            message: e
        })
        console.log(chatParams, "chatParams")

    }
    const handleTrendsClose = () => {
        setShowViewTrends(false)
        setIsCompare(false)
        setShowAdvanceSearch(false)
        setCheckedReportIds([])
        setCheckedReportsForCompare([]);
        setCheckedReports({});
    }
    const startSpeechRecognitionwhileChat = () => {
        if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
            return;
        }

        // Check if microphone permission is granted
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'microphone' }).then((permissionStatus) => {
                if (permissionStatus.state === 'denied') {
                    return;
                }
                toast.info('Listening...', { autoClose: 1000 });
                initializeSpeechRecognition();
            });
        } else {
            // Fallback for browsers that don't support permissions API
            toast.info('Listening...', { autoClose: 1000 });
            initializeSpeechRecognition();
        }
    };

    const initializeSpeechRecognition = () => {
        setIsRecording(true);

        // Initialize speech recognition
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        recognitionRef.current = new SpeechRecognition();

        // Configure recognition settings
        recognitionRef.current.continuous = false;
        recognitionRef.current.interimResults = true;
        recognitionRef.current.lang = 'en-US';

        // Handle results
        recognitionRef.current.onresult = (event) => {
            let finalTranscript = '';
            let interimTranscript = '';

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0].transcript;
                if (event.results[i].isFinal) {
                    finalTranscript += transcript;
                } else {
                    interimTranscript += transcript;
                }
            }

            // Update the message with the recognized text
            const recognizedText = finalTranscript || interimTranscript;
            if (recognizedText) {
                setNewMessage(recognizedText); // <-- This will show in LiveChat input!
                setChatParams({
                    ...chatParams,
                    message: recognizedText
                });


                if (interimTranscript && !finalTranscript) {
                    // toast.info('Listening...', { autoClose: 1000 });
                }
            }
        };

        // Handle errors
        recognitionRef.current.onerror = (event) => {
            console.error('Speech recognition error:', event.error);
            setIsRecording(false);

            switch (event.error) {
                case 'no-speech':
                    break;
                case 'audio-capture':
                    break;
                case 'not-allowed':
                    break;
                case 'network':
                    break;
                case 'service-not-allowed':
                    break;
                default:
            }
        };

        // Handle end of recognition
        recognitionRef.current.onend = () => {
            setIsRecording(false);
            // Auto-send message if there's content and it's final
            if (newMessage.trim()) {
                toast.success('Voice input completed!');
            }
        };

        // Start recognition
        try {
            recognitionRef.current.start();
            toast.info('🎤 Listening... Speak now!', { autoClose: 2000 });
        } catch (error) {
            console.error('Error starting speech recognition:', error);
            setIsRecording(false);
        }
    };

    const stopSpeechRecognitionwhileChat = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
            setIsRecording(false);
            toast.info('Stopped listening.');
        }
    };

    const handleSave = (res) => {
        setShowEditReportDialog(false)
        fetchReportsData(activeTab)
        // Calendar provider notes come from all reports (every category), not only Lab Results.
        refreshLabResults();
        refreshCalendarReports();
    }
    const handleReportCheck = (reportId, checked) => {
        setCheckedReports(prev => {
            const newCheckedReports = {
                ...prev,
                [reportId]: checked
            };
            console.log(newCheckedReports, "newCheckedReports")

            const checkedIds = Object.entries(newCheckedReports)
                .filter(([_, isChecked]) => isChecked)
                .map(([id]) => id);
            console.log(checkedIds, "checkedIds")

            // Find the row index for the current report (fix the bug: item.reportId not item.checkedIds)
            const rowIndex = rowData.findIndex(item => item.reportId === reportId);
            console.log(rowIndex, "rowIndex")

            // Update selected rows for multiple selection
            setCheckedReportIds(prev => {
                if (checked) {
                    // Add the row index to selected rows if not already present
                    return [...prev, rowIndex].filter((index, i, arr) => arr.indexOf(index) === i);
                } else {
                    // Remove the row index from selected rows
                    return prev.filter(index => index !== rowIndex);
                }
            });

            // Keep the last checked report as the primary selected row
            if (checked && rowIndex !== -1) {
                setSelectedRow(rowIndex);
                setSelectedReportID(reportId);
            } else if (!checked && selectedReportID === reportId) {
                // If unchecking the currently selected report, select another checked one
                const remainingCheckedIds = checkedIds.filter(id => id !== reportId);
                if (remainingCheckedIds.length > 0) {
                    const newSelectedId = remainingCheckedIds[0];
                    const newRowIndex = rowData.findIndex(item => item.reportId === newSelectedId);
                    if (newRowIndex !== -1) {
                        setSelectedRow(newRowIndex);
                        setSelectedReportID(newSelectedId);
                    }
                } else {
                    setSelectedRow(null);
                    setSelectedReportID(null);
                }
            }

            return newCheckedReports;
        });
    }

    const handleSelectAllReports = useCallback((checked) => {
        const validRows = rowData.filter(
            (r) => r && r.reportId !== '' && r.reportId != null
        );
        if (!checked || validRows.length === 0) {
            setCheckedReports({});
            setCheckedReportIds([]);
            setSelectedRow(null);
            setSelectedReportID(null);
            return;
        }
        const newCheckedReports = {};
        validRows.forEach((r) => {
            newCheckedReports[r.reportId] = true;
        });
        setCheckedReports(newCheckedReports);
        const indices = rowData
            .map((item, idx) =>
                item && item.reportId !== '' && item.reportId != null ? idx : -1
            )
            .filter((idx) => idx >= 0);
        setCheckedReportIds(indices);
        const last = validRows[validRows.length - 1];
        const lastIdx = rowData.findIndex((item) => item.reportId === last.reportId);
        if (lastIdx !== -1) {
            setSelectedRow(lastIdx);
            setSelectedReportID(last.reportId);
        }
    }, [rowData]);

    const validReportRowsForHeader = rowData.filter(
        (r) => r && r.reportId !== '' && r.reportId != null
    );
    const allReportsSelected =
        validReportRowsForHeader.length > 0 &&
        validReportRowsForHeader.every((r) => checkedReports[r.reportId]);
    const someReportsSelected =
        validReportRowsForHeader.some((r) => checkedReports[r.reportId]) &&
        !allReportsSelected;

    const columnDefs = [
        {
            colId: 'reportSelect',
            headerName: "",
            field: "checkbox",
            width: 42,
            minWidth: 42,
            maxWidth: 48,
            sortable: false,
            filter: false,
            resizable: false,
            suppressHeaderMenuButton: true,
            headerTooltip: "Select all reports",
            cellStyle: (params) => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
            }),
            headerComponent: () => (
                <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ width: '100%', height: '100%' }}
                >
                    <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ cursor: 'pointer', margin: 0 }}
                        aria-label={allReportsSelected ? 'Deselect all reports' : 'Select all reports'}
                        title={allReportsSelected ? 'Deselect all' : 'Select all'}
                        checked={allReportsSelected}
                        ref={(el) => {
                            if (el) el.indeterminate = someReportsSelected;
                        }}
                        onChange={(e) => handleSelectAllReports(e.target.checked)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            ),
            cellRenderer: (params) => {
                return (
                    <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100%' }}>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={checkedReports[params.data.reportId] || false}
                            onChange={(e) => handleReportCheck(params.data.reportId, e.target.checked)}
                            style={{ cursor: 'pointer', margin: 0 }}
                        />
                    </div>
                );
            },
        },
        {
            headerName: "Report Name",
            field: "name",
            tooltipField: "name",
            headerTooltip: "Report Name",
            flex: 2,
            sortable: true,
            filter: true,
            wrapText: true,
            autoHeight: true,
            cellClass: 'griddata-label text-decoration-underline',
            cellStyle: (params) => ({
                color: params.data.is_archived
                    ? '#ff0000'
                    : 'black',
                fontWeight: params.data.isNewattached ? 'bold' : '400',
                fontSize: '14px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                lineHeight: '1.4',
                display: 'flex',
                alignItems: 'center'
            }),
            cellRendererFramework: (params) => (
                <div
                    className="text-decoration-underline"
                    title={params.value}
                    style={{
                        color: params.data.is_archived
                            ? '#ff0000'
                            :'inherit',
                        fontWeight: params.data.isNewattached ? 600 : 'inherit',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                        lineHeight: '1.4',
                        width: '100%'
                    }}
                    onClick={() => {
                        console.log(params.data, "params.data")
                        const mockEvent = {
                            data: params.data
                        };
                        onRowClicked(mockEvent);
                    }}
                >
                    {params.value}
                </div>
            )
        },

        {
            headerName: "Report Date",
            field: "date",
            headerTooltip: "Report Date",
            flex: 1,
            sortable: true,
            filter: 'agDateColumnFilter',
            cellClass: 'griddata-label',
            comparator: (valueA, valueB) => compareReportDates(valueA, valueB),
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ),
            cellStyle: (params) => ({
                color: params.data.is_archived ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px'
            }),
        },
        {
            headerName: "Category",
            field: "category",
            headerTooltip: "Category",
            cellClass: 'griddata-label',
            flex: 1,
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ),
            hide: activeTab !== 'All',
            cellStyle: (params) => ({
                color: params.data.is_archived ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px',
            }),
        },
        {
            headerName: "Clinic/Diagnostics Center",
            headerTooltip: "Clinic/Diagnostics Center",
            field: "clinic",
            cellClass: 'griddata-label',
            flex: 2,
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold", color: "blue" }}>{params.value}</span>
            ),
            cellStyle: (params) => ({
                color: params.data.is_archived ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px',
                whiteSpace: 'wrap',
            }),
        },
    ];
    const getCheckedReportIds = () => {
        const checkedIds = Object.entries(checkedReports)
            .filter(([_, isChecked]) => isChecked)
            .map(([id]) => id);
        return checkedIds;
    };
    const invokeChatHistory = () => {
        setShowLiveChat(true)
        setShowChatNotification(false) // Hide notification when chat is opened
        setChatData([])
        setChatHistory([])
        dispatch(getChatHistory(params)).then((resp) => {
            //  console.log(resp, "for chat history AT uSERALNDING")
            if (resp.payload.messages.length > 0 && resp.payload.messages !== null) {
                setChatData(resp.payload.chats)

                const chatHistoryData = resp.payload.messages.map(item => ({
                    message: item.message,
                    sender_id: item.sender_id,
                    timestamp: item.timestamp,
                    message_id: item.message_id,
                    message_type: item.message_type,
                    message_type_id: item.message_type_id,
                    receiver_id: item.receiver_id,
                    isread: item.isread,
                    isread_on: item.isread_on,
                    chat_id: item.chat_id,
                    created_by: item.created_by,
                    created_by_name: item.created_by_name,
                    created_on: item.created_on,
                    file_name: item.file_name,
                    file_path: item.file_path,
                    image_name: item.image_name,
                    image_path: item.image_path,
                    media_path: item.media_path
                }))
                setChatHistory(chatHistoryData)
                //  console.log(chatHistoryData, "for chat history")
            } else {
                // Handle empty or invalid response
                setChatData([])
                setChatHistory([])
            }
        }).catch(error => {
            console.error('Error fetching chat history:', error);
            // Handle error state
            setChatData([])
            setChatHistory([])
        })
    }
    const handleEndChat = () => {
        console.log(chatData, "chatData")
        const chatEndParams = {
            chatId: chatData.length > 0 ? chatData[0].chat_id : null,
            token: token,
            isended: true
        }

        dispatch(endChat(chatEndParams)).then((resp) => {
            console.log(resp, "resp")
            if (resp.payload) {
                toast.success("Chat ended successfully.");
                setShowLiveChat(false)
                setChatData([])
                setChatHistory([])
                setShowLiveChat(false)
                // Reset notification for future messages
                setShowChatNotification(true)
                setChatNotificationCount(0)
            }

        })
    }

    // Function to show chat notification with count
    const showNewChatNotification = (count = 1) => {
        setShowChatNotification(true);
        setChatNotificationCount(count);
    }

    // Function to hide chat and reset notification
    const hideChatAndResetNotification = () => {
        setShowLiveChat(false);
        setShowChatNotification(true);
        setChatNotificationCount(0);
    }

    const getReportPerId = (event) => {
        console.log(event, "event selected report")

        const rawReportId = (event && typeof event === 'object')
            ? (event.reportId ?? event.report_id)
            : event;
        const reportId = Number(rawReportId);
        const requestUserId = Number(
            userId ||
            props.selectedFamilyMember?.user_id ||
            userData?.user_id ||
            userData?.UserID
        );
        if (!Number.isFinite(reportId) || reportId <= 0 || !Number.isFinite(requestUserId) || requestUserId <= 0) {
            setContentType(null);
            setPDFURL(null);
            setSelectedReport(null);
            setSelectedReportName(null);
            setSelectedReportID(null);
            setIsReportPreviewLoading(false);
            return;
        }
        setSelectedReportID(reportId)
        console.log(reportId, "reportId at EVENT")
        const params = {
            ReportID: reportId,
            UserID: requestUserId,
            token: token
        }
        console.log(params, "params for report per id")
        const previewRequestId = reportPreviewRequestIdRef.current + 1;
        reportPreviewRequestIdRef.current = previewRequestId;
        setIsReportPreviewLoading(true);
        setContentType(null);
        setPDFURL((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });

        dispatch(mrSitesReportsGetByReportID(params)).then(async (response) => {
            if (previewRequestId !== reportPreviewRequestIdRef.current) {
                return;
            }
            const resp = response?.payload;
            const failed = response?.meta?.requestStatus === 'rejected' || !(resp instanceof Blob) || await isNonPreviewableReportBlob(resp);
            if (failed) {
                setContentType(null);
                setPDFURL(null);
                setSelectedReport(null);
                setSelectedReportName(null);
                setSelectedReportID(null);
                return;
            }
            setContentType(resp.type || null);
            const blobUrl = URL.createObjectURL(resp);
            console.log('Created blob URL:', blobUrl);
            setPDFURL(blobUrl);
            setSelectedReportID(reportId);
            setSelectedReport(event)
            setReportData(event)
            setSelectedReportName(event?.name ? event.name : event?.report_name)
            console.log("PDF loaded for reportId:", reportId);
            setDeleteparams({
                UserID: requestUserId,
                ReportID: reportId,
                LoginUserID: requestUserId,
                token: token
            })
        }).catch(error => {
            if (previewRequestId !== reportPreviewRequestIdRef.current) {
                return;
            }
            console.error('Error fetching report:', error);
            setContentType(null);
            setPDFURL(null);
            setSelectedReport(null);
            setSelectedReportName(null);
            setSelectedReportID(null);
        }).finally(() => {
            if (previewRequestId === reportPreviewRequestIdRef.current) {
                setIsReportPreviewLoading(false);
            }
        })
    }


    const onRowClicked = (event) => {
        console.log(event, "event at onRowClicked")
        // Always load preview on row click. Checkbox selection is only for bulk
        // email/download/compare — it must not block opening a report in the preview pane.
        setSelectedRow(event.rowIndex)
        setReportData(event.data)
        const reportId = event.data;
        getReportPerId(reportId)

        console.log(event.data, "event selected report")
        setSelectedReport(event.data)
        setSelectedReportName(event.data.name)
        setSelectedReportID(event.data.reportId)
        setDeleteparams({
            UserID: userId,
            ReportID: event.data.reportId,
            LoginUserID: userId,
            token: token
        })
        setArchiveparams({
            UserID: userId,
            ReportID: event.data.reportId,
            LoginUserID: userId,
            token: token
        })

        setTogglePDF(!togglePDF);
    };


    const setLogUserMenuAnalytics = (event, boolean) => {
        const tab = boolean
            ? (event?.group_name || event?.category || 'All')
            : (event?.label || 'All');

        if (props.activeMenuItem?.showProfile === true) {
            return;
        }

        setStartDate(null);
        setEndDate(null);
        if (boolean && event && (event.reportId != null || event.report_id != null)) {
            setPendingReportPreview({
                ...event,
                reportId: event.reportId ?? event.report_id,
                name: event.name || event.report_name,
                group_name: event.group_name || event.category || tab,
                category: event.category || event.group_name || tab,
            });
        }
        if (typeof props.onViewReportsClick === 'function') {
            props.onViewReportsClick({
                menu_id: 2,
                parent_id: 2,
                title: tab,
                name: tab,
            });
        }
    }

    // Format a JS date to the MM/DD/YYYY string the reports API expects
    const formatDateForReportAPI = (date) => {
        if (!date) return null;
        const d = new Date(date);
        if (isNaN(d.getTime())) return null;
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };

    // When a specific provider note is opened from the calendar, land on its category tab.
    const pendingReportCategoryRef = useRef('All');

    // Called from the HealthCare Calendar when a user clicks a date / provider note.
    // Switches to the Reports view. When a specific provider note is clicked, open that
    // report's category tab and preview it; otherwise filter the grid to the clicked day.
    const handleCalendarDateToReports = (date, report) => {
        const filterByDate = !report;
        const formatted = filterByDate ? formatDateForReportAPI(date) : null;
        const categoryTab = report
            ? (report.group_name || report.category || 'All')
            : 'All';

        // Set category first so Reports tabs / menu-driven fetches land on the right group
        pendingReportCategoryRef.current = categoryTab;
        setActiveTab(categoryTab);

        setStartDate(filterByDate ? (date || null) : null);
        setEndDate(filterByDate ? (date || null) : null);
        setViewReportData(prev => ({
            ...prev,
            user_id: userId,
            ReportDateStart: formatted,
            ReportDateEnd: formatted,
            token: token,
        }));
        // Navigate via landingPage setActiveMenuItems (immutable) — do not mutate props
        if (typeof props.onViewReportsClick === 'function') {
            props.onViewReportsClick({
                menu_id: 2,
                parent_id: 2,
                title: categoryTab,
                name: categoryTab,
            });
        }
        setPendingReportPreview(report && report.reportId != null ? report : null);
        setPendingReportDate(date || 'all');
    };

    // Once the view has switched to Reports and viewReportData carries the selected
    // date range, fetch reports for the target category (or All for day-only clicks).
    useEffect(() => {
        if (pendingReportDate && props.activeMenuItem && props.activeMenuItem.showReports) {
            const tab = pendingReportCategoryRef.current || 'All';
            fetchReportsData(tab);
            setPendingReportDate(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingReportDate, viewReportData]);

    // Switching to the Reports view kicks off more than one grid fetch (this navigation
    // plus the menu-driven one), and each of them resets the preview pane. So wait until
    // every request has settled and the report is actually in the grid before opening it.
    useEffect(() => {
        if (!pendingReportPreview) return;
        if (!props.activeMenuItem || !props.activeMenuItem.showReports) return;
        if (isReportsGridLoading || reportsGridLoadInflightRef.current > 0) return;

        const preview = pendingReportPreview;
        const wantedCategory = preview.group_name || preview.category || '';
        if (wantedCategory && activeTab !== wantedCategory) return;

        const row = rowData.find(
            (r) => String(r.reportId) === String(preview.reportId)
        );
        if (!row && rowData.length === 0) return;

        setPendingReportPreview(null);
        if (row) {
            getReportPerId(row);
        } else if (preview && preview.reportId != null) {
            getReportPerId({
                name: preview.name || preview.report_name,
                date: preview.date || preview.report_date,
                category: preview.group_name || preview.category,
                clinic: preview.clinic,
                url: preview.url,
                reportId: preview.reportId,
                provider_name: preview.provider_name,
                edit_report_name: preview.edit_report_name,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingReportPreview, isReportsGridLoading, rowData, activeTab, props.activeMenuItem]);

    const getUniqueReports = (data) => {
        const seen = new Set();
        const uniqueReports = data.filter(report => {
            if (seen.has(report.reportId)) {
                return false;
            }
            seen.add(report.reportId);
            return true;
        });
        return uniqueReports;
    };

    const onRefresh = (activeTab) => {
        setActiveTab(activeTab);
        setRowData([]);
        setRowDatanew([]);
        setSelectedRow(null);
        setSelectedReportID(null);
        setPDFURL(null);

        // Refresh the groups list to include newly added report types
        dispatch(getgridHeaders(params)).then((response) => {
            setGridHeaers(response.payload || []);
            const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
                name: report.name,
                id: report.id
            }));
            const formattedDataforGroupList = (response.payload || []).map(report => ({
                category: report.name,
                id: report.id
            }));
            setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
            setGroupsLst(formattedDataforGroupList);
        });

        if (props.activeMenuItem.showDashBoard) {
            const labdata = {
                user_id: userId,
                token: token
            }

            setLabResultsLoading(true);
            dispatch(getLabResultatDashboard(labdata)).then((response) => {
                setLabResults([]);
                if (response.payload !== undefined) {
                    const labResultData = response.payload;
                    console.log(labResultData, "labResultData at onRefresh")


                    const formattedData = labResultData.map(labResult => ({
                        name: labResult.report_name,
                        date: labResult.report_date,
                        group_name: labResult.group_name,
                        clinic: labResult.hospital_name,
                        url: labResult.report_path,
                        reportId: labResult.report_id,
                        group_id: labResult.group_id,
                        provider_name: labResult.provider_name,
                        edit_report_name: labResult.edit_report_name


                    }));
                    setLabResults(formattedData);
                }

            }).finally(() => {
                setLabResultsLoading(false);
            });

            dispatch(getVitals(labdata)).then((response) => {
                // setVitalsData([]);
                setSeriesData([]);
                setHeartRateData([]);
                setBloodSugarData([]);
                setWeightData([]);
                setWaistSizeData([]);
                setVitalsValues({});

                const vitalsData = response.payload || [];
                console.log(vitalsData, "vitalsData")
                const systolicData = [];
                const diastolicData = [];
                const heartRateData = [];
                const bloodSugarData = [];
                const weightData = [];
                const waistSizeData = [];

                vitalsData.forEach(vital => {
                    if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                        systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                        diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                    }
                    if (vital.LastUpdated && vital.HeartRate) {
                        heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                    }
                    if (vital.LastUpdated && vital.BloodSugar) {
                        bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                    }
                    if (vital.LastUpdated && vital.Weight) {
                        weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                    }
                    if (vital.LastUpdated && vital.WaistSize) {
                        waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                    }
                });

                setSeriesData([
                    { name: 'Systolic', data: systolicData },
                    { name: 'Diastolic', data: diastolicData },
                ]);
                setHeartRateData([
                    { name: 'Heart Rate', data: heartRateData },
                ]);
                setBloodSugarData([
                    { name: 'Blood Sugar', data: bloodSugarData },
                ]);
                setWeightData([
                    { name: 'Weight', data: weightData },
                ]);
                setWaistSizeData([
                    { name: 'Waist Size', data: waistSizeData },
                ]);

                const latestVital = vitalsData[vitalsData.length - 1] || {};
                setVitalsValues({
                    BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                        ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                        : "0",
                    HeartRate: latestVital.HeartRate || "0",
                    BloodSugar: latestVital.BloodSugar || "0",
                    Weight: latestVital.Weight || "0",
                    WaistSize: latestVital.WaistSize || "0",
                });
            });
        }
        if (includeArchivedforReports) {
            fetchArchivedReportsData(activeTab)

        } else {
            fetchReportsData(activeTab)
        }


    }

    // Refresh only the Vitals & Metabolics data. Used by the AddVitals modal so that
    // saving vitals/metabolics does NOT trigger a full dashboard refresh (which would
    // needlessly reload Lab Results and reports).
    const refreshVitalsData = (overrideUserId) => {
        const labdata = {
            user_id: overrideUserId || props.selectedFamilyMember?.user_id || userId,
            token: token
        };

        dispatch(getVitals(labdata)).then((response) => {
            setSeriesData([]);
            setHeartRateData([]);
            setBloodSugarData([]);
            setWeightData([]);
            setWaistSizeData([]);
            setVitalsValues({});

            const vitalsData = response.payload || [];
            // Calendar day chips read from vitalsRaw — keep it in sync so new
            // vitals/metabolics show without a full page refresh.
            setVitalsRaw(Array.isArray(vitalsData) ? vitalsData : []);
            const systolicData = [];
            const diastolicData = [];
            const heartRateData = [];
            const bloodSugarData = [];
            const weightData = [];
            const waistSizeData = [];

            vitalsData.forEach(vital => {
                if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                    systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                    diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                }
                if (vital.LastUpdated && vital.HeartRate) {
                    heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                }
                if (vital.LastUpdated && vital.BloodSugar) {
                    bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                }
                if (vital.LastUpdated && vital.Weight) {
                    weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                }
                if (vital.LastUpdated && vital.WaistSize) {
                    waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                }
            });

            setSeriesData([
                { name: 'Systolic', data: systolicData },
                { name: 'Diastolic', data: diastolicData },
            ]);
            setHeartRateData([
                { name: 'Heart Rate', data: heartRateData },
            ]);
            setBloodSugarData([
                { name: 'Blood Sugar', data: bloodSugarData },
            ]);
            setWeightData([
                { name: 'Weight', data: weightData },
            ]);
            setWaistSizeData([
                { name: 'Waist Size', data: waistSizeData },
            ]);

            const latestVital = vitalsData[vitalsData.length - 1] || {};
            setVitalsValues({
                BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                    ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                    : "0",
                HeartRate: latestVital.HeartRate || "0",
                BloodSugar: latestVital.BloodSugar || "0",
                Weight: latestVital.Weight || "0",
                WaistSize: latestVital.WaistSize || "0",
            });
        });
    }

    // Calendar provider-note chips are driven by labResults (loaded once on dashboard
    // mount). Re-fetch after report edit / upload / delete / archive so date changes
    // (including updating a report to today) appear on the correct calendar day.
    const refreshLabResults = () => {
        const labdata = {
            user_id: userId,
            token: token
        };
        setLabResultsLoading(true);
        dispatch(getLabResultatDashboard(labdata)).then((response) => {
            if (response.payload !== undefined) {
                const labResultData = response.payload || [];
                const formattedData = labResultData.map(labResult => ({
                    name: labResult.report_name,
                    date: labResult.report_date,
                    category: labResult.group_name,
                    group_name: labResult.group_name,
                    clinic: labResult.hospital_name,
                    url: labResult.report_path,
                    reportId: labResult.report_id,
                    group_id: labResult.group_id,
                    provider_name: labResult.provider_name,
                    edit_report_name: labResult.edit_report_name
                }));
                setLabResults(formattedData);
            } else {
                setLabResults([]);
            }
        }).finally(() => {
            setLabResultsLoading(false);
        });
    };

    // Fetch ALL report categories for the HealthCare Calendar (Blood work, Cardiology, etc.)
    const refreshCalendarReports = (overrideUserId) => {
        const effectiveUserId =
            overrideUserId ||
            props.selectedFamilyMember?.user_id ||
            userId;
        const payload = {
            user_id: effectiveUserId,
            token: token,
            SearchKey: '',
            ReportGroupName: '',
            ProviderName: '',
            HospitalName: '',
            ReportDateStart: null,
            ReportDateEnd: null,
            SiteID: 0,
            IncludeArchived: false,
            ReportID: 0,
        };
        dispatch(getMRSitesReports(payload)).then((response) => {
            const table = response.payload?.Table || [];
            const formatted = table.map((report) => ({
                name: report.report_name,
                date: report.report_date,
                category: report.group_name,
                group_name: report.group_name,
                clinic: report.hospital_name,
                url: report.report_path,
                reportId: report.report_id,
                group_id: report.group_id,
                provider_name: report.provider_name,
                edit_report_name: report.edit_report_name,
                is_archived: report.is_archived,
            }));
            setCalendarReports(getUniqueReports(formatted));
        }).catch(() => {
            setCalendarReports([]);
        });
    };





    const includeArchived = (activeTab) => {
        setRowDatanew([]);
        setIncludeArchivedforReports(prevState => !prevState);
        if (!includeArchivedforReports) {
            fetchArchivedReportsData(activeTab)

        } else {
            fetchReportsData(activeTab)
        }
    };

    const onArchiveUndo = () => {
        // Prevent double execution
        if (isUnarchiveProcessing || unarchiveModalShownRef.current) {
            console.log("Unarchive already in progress or modal already shown, skipping...");
            return;
        }

        console.log(archiveparams, "archiveparams at onArchiveUndo")
        setIsUnarchiveProcessing(true);
        unarchiveModalShownRef.current = true;
        // Reset modal state first to prevent double showing
        setShowArchiveSuccessModal(false);
        setShowUnarchiveSuccessModal(false);
        setShowDeleteSuccessModal(false);

        dispatch(undoarchiveMRSItesReports(archiveparams)).then((resp) => {
            console.log("resp", resp);
            if (resp.payload) {
                // Use setTimeout to ensure state is properly reset before showing modal
                setTimeout(() => {
                    setShowUnarchiveSuccessModal(true);
                    setIsUnarchiveProcessing(false);
                }, 100);
                setRowDatanew([]);
                setRowData([]);
                setPDFURL(null);
                setSelectedRow(null);
                setSelectedReportID(null);
                setStartDate(null);
                setEndDate(null);
                setSearchQuery("");
                if (includeArchivedforReports) {
                    fetchArchivedReportsData(activeTab)
                } else {
                    fetchReportsData(activeTab)
                }
                refreshLabResults();
                refreshCalendarReports();
            } else {
                setIsUnarchiveProcessing(false);
                unarchiveModalShownRef.current = false;
            }
        }).catch((error) => {
            console.error("Unarchive error:", error);
            setIsUnarchiveProcessing(false);
            unarchiveModalShownRef.current = false;
        });
    }
    const handleBloodWorkSummary = () => {
        console.log("handleBloodWorkSummary")
        setShowPatientSummaryDialog(true);
        const reportId = selectedReport.reportId;
        const summaryParams = {
            ReportID: reportId,
            UserID: userId,
            token: token,
            SiteID: 0,
            ReportDateStart: null,
            ReportDateEnd: null,
            ReportGroupName: '',
            ProviderName: '',
            HospitalName: '',
            SearchKey: '',

        }
        console.log(summaryParams, "params for report per id")
        dispatch(getMRSitesReports(summaryParams)).then((resp) => {
            console.log(resp.payload.Table[0], "resp for blood work summary")
            const bloodWorkSummary = resp.payload.Table[0].summary;
            console.log(bloodWorkSummary, "bloodWorkSummary")
            setBloodWorkSummary(bloodWorkSummary)
        })

    }

    const handlePatientSummaryClick = (userId, name) => {
        console.log("Patient summary clicked for:", { userId, name });

        // Store the patient info in localStorage like the provider does
        localStorage.setItem('patientUserId', userId);
        localStorage.setItem('patientUserName', name);

        // Set states to show patient details view (similar to provider logic)
        setIsPatientDetailsView(true);
        setSelectedPatientName(name);
        setIsFromDetails(true);
        setIsFromReports(false);

        // Update activeMenuItem to show dashboard for the selected patient
        if (props.activeMenuItem) {
            props.activeMenuItem.showSharedReports = false;
            // Don't set showDashBoard to true if profile is active
            if (!props.activeMenuItem.showProfile) {
                props.activeMenuItem.showDashBoard = true;
            }
        }
    }

    const handleReportIconClick = (userId, name) => {
        console.log("Report icon clicked for:", { userId, name });

        // Store the patient info in localStorage
        localStorage.setItem('patientUserId', userId);
        localStorage.setItem('patientUserName', name);

        // Set states for reports view
        setIsPatientDetailsView(true);
        setSelectedPatientName(name);
        setIsFromDetails(false);
        setIsFromReports(true);

        // Update activeMenuItem to show reports for the selected patient
        if (props.activeMenuItem) {
            props.activeMenuItem.showReports = true;
            props.activeMenuItem.showSharedReports = false;
            // Don't set showDashBoard to true if profile is active
            if (!props.activeMenuItem.showProfile) {
                props.activeMenuItem.showDashBoard = true;
            }
        }
    }

    const handleBackToSharedReports = () => {
        setIsPatientDetailsView(false);
        setIsFromDetails(false);
        setIsFromReports(false);
        setSelectedPatientName('');

        // Restore shared reports view
        if (props.activeMenuItem) {
            props.activeMenuItem.showSharedReports = true;
            props.activeMenuItem.showDashBoard = false;
            props.activeMenuItem.showReports = false;
        }

        // Call parent's onViewReportsClick to properly reset the view
        const activeTab = { menu_id: 4 };
        props.onViewReportsClick(activeTab);
    }



    const setGridData = (event) => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        searchRequestIdRef.current += 1;
        searchWasActiveRef.current = false;

        setSearchQuery("");
        setShowBlink(false);
        setStartDate(null);
        setEndDate(null);
        setShowAdvanceSearch(false);
        setSelectedCategories([]);
        setSelectedProviders([]);
        setSelectedHospitals([]);
        setReportGroupNames("");
        setSelectedRow(null);
        setSelectedReportID(null);
        setCheckedReports({});
        setCheckedReportIds([]);
        setIsSelectedBloodWork(event.name === "Blood work");
        clearReportPreview();

        const tabName = event.name || "All";
        const hasFullList = Array.isArray(rowDatanew) && rowDatanew.length > 0 && !searchWasActiveRef.current && !showAdvanceSearch;
        if (hasFullList) {
            reportsFetchIdRef.current += 1;
            setActiveTab(tabName);
            const nextRows = tabName === "All"
                ? rowDatanew
                : rowDatanew.filter((report) => report.category === tabName);
            setRowData(nextRows);
            return;
        }

        const clearedFilters = {
            SearchKey: "",
            ReportGroupName: "",
            ProviderName: "",
            HospitalName: "",
            ReportDateStart: null,
            ReportDateEnd: null,
        };
        setViewReportData((prev) => ({
            ...prev,
            ...clearedFilters,
            user_id: userId,
            token: token,
            SiteID: '',
            IncludeArchived: false,
        }));
        setViewReportDataforArchived((prev) => ({
            ...prev,
            ...clearedFilters,
            user_id: userId,
            token: token,
            SiteID: '',
            IncludeArchived: true,
        }));

        if (includeArchivedforReports) {
            fetchArchivedReportsData(event.name, undefined, clearedFilters, rowData.length === 0);
        } else {
            fetchReportsData(event.name, undefined, clearedFilters, rowData.length === 0);
        }
    };

  const SEARCH_DEBOUNCE_MS = 500;
  const SEARCH_MIN_CHARS = 3;

  const clearReportPreview = () => {
      reportPreviewRequestIdRef.current += 1;
      setPDFURL((prev) => {
          if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
              URL.revokeObjectURL(prev);
          }
          return null;
      });
      setContentType(null);
      setIsReportPreviewLoading(false);
      setSelectedReport(null);
      setSelectedReportName(null);
      setSelectedReportID(null);
      setSelectedRow(null);
  };

  const onSearch = (event) => {
       const searchValue = event.target.value;
       clearReportPreview();
       setSearchQuery(searchValue);

       const effectiveUserId =
           props.selectedFamilyMember?.user_id ||
           viewReportData.user_id ||
           userId;

       const updatedViewReportData = {
           ...viewReportData,
           user_id: effectiveUserId,
           SearchKey: searchValue
       };
       setViewReportData(updatedViewReportData);

       const updatedViewReportDataforArchived = {
           ...viewReportDataforArchived,
           user_id: effectiveUserId,
           SearchKey: searchValue
       };
       setViewReportDataforArchived(updatedViewReportDataforArchived);

       if (searchDebounceRef.current) {
           clearTimeout(searchDebounceRef.current);
           searchDebounceRef.current = null;
       }

       if (searchValue.trim().length < SEARCH_MIN_CHARS) {
           searchRequestIdRef.current += 1;
           if (searchWasActiveRef.current) {
               searchWasActiveRef.current = false;
               setViewReportData({
                   ...updatedViewReportData,
                   SearchKey: ""
               });
               setViewReportDataforArchived({
                   ...updatedViewReportDataforArchived,
                   SearchKey: ""
               });
               setRowData([]);
               setRowDatanew([]);
               setShouldRefetchAfterClear(true);
           }
           return;
       }

       searchWasActiveRef.current = true;
       const searchRequestId = searchRequestIdRef.current + 1;
       searchRequestIdRef.current = searchRequestId;

       searchDebounceRef.current = setTimeout(() => {
           searchDebounceRef.current = null;
           setRowData([]);
           setRowDatanew([]);
           beginReportsGridLoad();

           // When "Include Archived Reports" is ON, search across archived reports
           // by dispatching the archived payload (IncludeArchived: true). Otherwise
           // search only the non-archived reports.
           const requestPayload = includeArchivedforReports
               ? { ...updatedViewReportDataforArchived, token: token, IncludeArchived: true }
               : { ...updatedViewReportData, token: token, IncludeArchived: false };

           dispatch(getMRSitesReports(requestPayload)).then((resp) => {
               if (searchRequestId !== searchRequestIdRef.current) {
                   return;
               }

               if (!resp.payload || !resp.payload.Table || resp.payload.Table.length === 0) {
                   setRowData([]);
                   setRowDatanew([]);
                   return;
               }

               const fetchedData = resp.payload.Table;
               console.log("Search results:", fetchedData);

               const reportData = fetchedData.map(report => ({
                   name: report.report_name,
                   date: report.report_date,
                   category: report.group_name,
                   clinic: report.hospital_name,
                   url: report.report_path,
                   reportId: report.report_id,
                   is_archived: report.is_archived,
                   provider_name: report.provider_name,
                   isNewattached: report.isNewattached,
                   isHighlight: report.isHighlight,
                   edit_report_name: report.edit_report_name
               }));

               const uniqueReports = getUniqueReports(reportData);
               console.log("Unique search results:", uniqueReports);

               if (activeTab === 'All') {
                   setRowData(uniqueReports);
                   setRowDatanew(uniqueReports);
               } else {
                   const filteredReports = uniqueReports.filter(report => report.category === activeTab);
                   setRowData(filteredReports);
                   setRowDatanew(uniqueReports);
               }
           }).catch(error => {
               console.error("Error searching reports:", error);
               setRowData([]);
               setRowDatanew([]);
           }).finally(() => {
               endReportsGridLoad();
           });
       }, SEARCH_DEBOUNCE_MS);
   };

    const onClear = (event) => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        searchRequestIdRef.current += 1;
        searchWasActiveRef.current = false;

        setShowBlink(false);
        setSearchQuery("");
        setStartDate(null);
        setEndDate(null);
        setShowAdvanceSearch(false)
        setCategoryAdvanceSearch([])
        setSelectedCategories([]);
        setSelectedProviders([]);
        setSelectedHospitals([]);
        setReportGroupNames("")

        const updatedViewReportData = {
            ...viewReportData,
            SearchKey: "",
            ReportGroupName: "",
            ProviderName: "",
            HospitalName: "",
            ReportDateStart: null,
            ReportDateEnd: null
        };
        setViewReportData(updatedViewReportData);

        setViewReportDataforArchived(prevData => ({
            ...prevData,
            SearchKey: "",
            ReportGroupName: "",
            ProviderName: "",
            HospitalName: "",
            ReportDateStart: null,
            ReportDateEnd: null
        }));

        setRowData([]);
        setRowDatanew([]);

        // Defer the refetch until after viewReportData has been committed so the
        // request is sent with the cleared SearchKey/filters instead of the
        // stale closure values. The useEffect watching shouldRefetchAfterClear
        // will trigger fetchReportsData / fetchArchivedReportsData.
        setShouldRefetchAfterClear(true);
    };
    const handleEmailClick = () => {
        console.log("handleEmailClick")
        setShowMultipleEmailDialog(true);
    }

    const clearReportCheckboxSelections = () => {
        setCheckedReports({});
        setCheckedReportIds([]);
        if (gridRef.current?.api) {
            gridRef.current.api.refreshCells({ columns: ['reportSelect'], force: true });
            gridRef.current.api.redrawRows();
        }
    };

    const handleMultipleEmailSave = (payload) => {
        const report_ids = payload?.report_ids;
        if (report_ids == null || report_ids === '') {
            toast.error('Select at least one report to send by email.');
            return;
        }
        clearReportCheckboxSelections();
        void dispatch(sendEmail(payload))
            .unwrap()
            .catch(() => {
                toast.error('Could not send email. Please try again.');
            });
    };
    const handleMultipleDownloadClick = async () => {
        const idList = (emailDialogSelectedReports || [])
            .map((r) => r?.reportId)
            .filter((id) => id != null && String(id).trim() !== '');

        if (idList.length === 0) {
            toast.error('Select at least one report to download.');
            return;
        }

        const reportIds = idList.join(',');
        const numericUserId = Number(userId);
        const payload = {
            reportIds,
            userId: Number.isFinite(numericUserId) ? numericUserId : userId,
            token,
        };

        try {
            const response = await dispatch(downloadMultipleReports(payload)).unwrap();
            const fileName = response?.fileName || 'Reports.zip';

            setDownloadAlertFileName(fileName);
            setDownloadAlertMessage(
                idList.length > 1
                    ? `${idList.length} reports downloaded successfully.`
                    : 'Report downloaded successfully.'
            );
            setShowDownloadSuccessModal(true);
        } catch (e) {
            toast.error('Could not download reports. Please try again.');
            throw e;
        }

    }

    const handleClear = () => {
        setSearchQuery("");
        setPDFURL(null);
        setContentType(null);
        setIsReportPreviewLoading(false);
        setSelectedReportName('');
        setSelectedRow(null);
        setSelectedReportID(null);
        setStartDate(null);
        setEndDate(null);
        onClear();

        // Exit fullscreen if currently in fullscreen mode
        if (document.fullscreenElement) {
            document.exitFullscreen()
                .then(() => {
                    setIsFullscreen(false);
                })
                .catch(err => {
                    console.error(`Error exiting fullscreen: ${err.message}`);
                    setIsFullscreen(false);
                });
        } else {
            setIsFullscreen(false);
        }
    };

    const handleSearchClear = () => {
        clearReportPreview();
        setSearchQuery("");
        onClear();
    };

    const handleViewTrends = () => {
        setShowViewTrends(true);
    };
    const handleCompareReports = () => {
        setPDFURL(null)
        const selectedIds = getCheckedReportIds();
        console.log(selectedIds, "selectedIds")
        if (selectedIds.length < 2) {
            setBloodReportsAlertMessage("Please select at least 2 blood reports to compare");
            setShowBloodReportsAlert(true)
        } else if (selectedIds.length > 2) {
            setBloodReportsAlertMessage("Please select only 2 reports to compare");
            setShowBloodReportsAlert(true)
        } else {
            const reportsToCompare = rowDatanew.filter(row => selectedIds.includes(String(row.reportId)));
            setCheckedReportsForCompare(reportsToCompare);
            setCheckedReportIds(selectedIds)
            setShowViewTrends(true);
            setIsCompare(true);
        }

    };
    const medColumns = [
        {
            headerName: "Medication",
            field: "medication",
            tooltipValueGetter: (params) => {
                const medication = params.value || "N/A";
                const dose = params.data?.dose || '';
                return dose ? `${medication} (${dose})` : medication;
            },
            headerTooltip: "Medication",
            cellRenderer: (params) => {
                const medication = params.value || "N/A";
                const dose = params.data?.dose || '';
                const displayText = dose ? `${medication} (${dose})` : medication;
                return (
                    <div style={{ fontSize: '12px', color: 'gray', fontWeight: '500' }}>{displayText}</div>
                );
            },
            headerStyle: {
                fontSize: '10px',
                fontWeight: 'bold'
            },
            filter: true,
            flex: 1,
            minWidth: 80
        },
        {
            headerName: "Frequency",
            field: "frequency",
            tooltipValueGetter: (params) => {
                const frequency = params.value || "N/A";
                return frequency;
            },
            headerTooltip: "Frequency",
            cellRenderer: (params) => {
                const frequency = params.value || "N/A";
                return (
                    <div style={{ fontSize: '12px', color: 'gray', fontWeight: '500' }}>{frequency}</div>
                );
            },
            headerStyle: {
                fontSize: '10px',
                fontWeight: 'bold'
            },
            filter: true,
            flex: 1,
            minWidth: 80
        },
    ];

    const labColumns = [
        {
            headerName: "Report Name", field: "name", headerTooltip: "Report Name", tooltipField: "name",
            flex: 2,
            minWidth: 120,
            wrapText: true,
            autoHeight: true,
            cellClass: 'lab-report-name-wrap',
            cellRenderer: (params) => {
                const name = params.data?.name || params.data?.edit_report_name || "N/A";
                const path = params.data?.url;
                return path ? (
                    <div
                        onClick={() => getReportPerId(params.data.reportId)}
                        rel="noopener noreferrer"
                        className="text-decoration-underline lab-report-name-full"
                        style={{
                            fontSize: '12px',
                            color: 'gray',
                            fontWeight: '500',
                            width: '100%'
                        }}
                    >
                        {name}
                    </div>
                ) : (
                    <div style={{ fontSize: '12px' }}>N/A</div>
                );
            },

            headerStyle: {
                fontSize: '10px',
                fontWeight: 'bold',
            }

        },
        {
            headerName: "Report Date", field: "date", cellClass: "center-content",
            headerClass: "lab-report-date-hide-sort-icon",
            flex: 1,
            minWidth: 140,
            sortable: true,
            filter: true,
            comparator: (valueA, valueB) => compareReportDates(valueA, valueB),
            cellRenderer: (params) => {
                const date = params.value || "N/A";
                return (
                    <div style={{ fontSize: '12px', color: 'gray', fontWeight: '500' }} title={date}>{date}</div>
                );
            },
            headerStyle: {
                fontSize: '10px',
                fontWeight: 'bold'
            }
        },
    ];


    const handleAddVitals = () => {
        // Handle adding vitals
    };




    const [showUploadModal, setShowUploadModal] = useState(false);


    const [seriesData, setSeriesData] = useState([
        { name: 'Systolic', data: [] },
        { name: 'Diastolic', data: [] },
    ]);

    const [seriesDataforHeartRate, setHeartRateData] = useState([
        { name: 'Heart Rate', data: [] },
    ]);

    const [seriesDataforBloodSugar, setBloodSugarData] = useState([
        { name: 'Blood Sugar', data: [] },])

    const [seriesDataforWeight, setWeightData] = useState([
        { name: 'Weight', data: [] },])

    const [seriesDataforWaistSize, setWaistSizeData] = useState([
        { name: 'Waist Size', data: [] },])

    const [reportToDelete, setReportToDelete] = useState(null);

    const onDelete = () => {
        showPmrDeleteConfirm({
            message: 'You want to delete this report? This action cannot be undone.',
        }).then((result) => {
            if (result.isConfirmed) {
                handleConfirmDelete();
            }
        });
    };

    const onArchive = () => {
        showPmrDeleteConfirm({
            title: 'Confirm Archive',
            message: 'Are you sure you want to archive this report? It will remain archived for 30 days only, after which it will be permanently deleted.',
            confirmText: 'Yes, archive it!',
        }).then((result) => {
            if (result.isConfirmed) {
                handleConfirmArchive();
            }
        });
    };

    const handleConfirmDelete = () => {
        console.log(deleteparams, "deleteparams at handleConfirmDelete")
        dispatch(deleteReports(deleteparams)).then((resp) => {
            console.log("resp", resp);
            if (resp.payload) {
                setPDFURL(null);
                setSelectedReport(null);
                setSelectedReportName(null);
                setSelectedReportID(null);
                setShowDeleteSuccessModal(true);
                setRowDatanew([])
                setAlertMessage("Report deleted successfully.");
                //toast.success("Report  deleted successfully.");
                if (includeArchivedforReports) {
                    fetchArchivedReportsData(activeTab)

                } else {
                    fetchReportsData(activeTab)
                }
                refreshLabResults();
                refreshCalendarReports();

            }
        })
    };

    const handleConfirmArchive = () => {
        // Prevent double execution
        if (isArchiveProcessing || archiveModalShownRef.current) {
            console.log("Archive already in progress or modal already shown, skipping...");
            return;
        }

        console.log("Archive confirmed.");
        setIsArchiveProcessing(true);
        archiveModalShownRef.current = true;
        setReportToDelete(null);
        setRowDatanew([]);
        // Reset modal state first to prevent double showing
        setShowArchiveSuccessModal(false);
        setShowUnarchiveSuccessModal(false);
        setShowDeleteSuccessModal(false);

        dispatch(archiveReport(archiveparams)).then((resp) => {
            console.log("resp", resp);
            if (resp.payload) {
                // Use setTimeout to ensure state is properly reset before showing modal
                setTimeout(() => {
                    setShowArchiveSuccessModal(true);
                    setIsArchiveProcessing(false);
                }, 100);
                if (includeArchivedforReports) {
                    fetchArchivedReportsData(activeTab)

                } else {
                    fetchReportsData(activeTab)
                }
                refreshLabResults();
                refreshCalendarReports();
            } else {
                setIsArchiveProcessing(false);
                archiveModalShownRef.current = false;
            }
        }).catch((error) => {
            console.error("Archive error:", error);
            setIsArchiveProcessing(false);
            archiveModalShownRef.current = false;
        });
    };

    const handleDownload = () => {
        if (!selectedReportID) {
            return;
        }
        console.log("Attempting to download report:", selectedReportID, selectedReportName);
        // toast.info("Preparing download...");

        const downloadParams = {
            ReportID: selectedReportID,
            UserID: userId,
            token: token
        };

        if (!downloadParams.UserID || !downloadParams.token) {
            console.error("Missing user_id or token for download", { userData, token });
            return;
        }

        dispatch(mrSitesReportsGetByReportID(downloadParams))
            .unwrap()
            .then(async (blob) => {
                console.log("Received blob data for download:", blob);

                if (!(blob instanceof Blob)) {
                    console.error("API did not return a valid Blob object.");
                    return;
                }
                if (blob.size === 0) {
                    console.error("Received empty blob.");
                    return;
                }

                const blobUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = blobUrl;

                const filename = await getReportDownloadFilename({
                    blob,
                    reportName: selectedReportName,
                    reportId: selectedReportID,
                });
                link.download = filename;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(blobUrl);
                setAlertFileName(filename);
                setAlertMessage(`downloaded successfully.`);
                setShowDeleteSuccessModal(true);

            })
            .catch((error) => {
                console.error("Error fetching report for download:", error);
            });
    };

    const handleShare = () => {
        console.log("Sharing report:", selectedReportID, selectedReportName);
        setShowShareReportDialog(true);
    };

    const handleEdit = () => {
        console.log("Editing report:", selectedReportID, selectedReportName);
        setShowEditReportDialog(true);
    };
    const handleNotes = (e) => {
        setShowNotesDialog(true);
    };


    const [categoryAdvanceSearch, setCategoryAdvanceSearch] = useState([]);


    const beginReportsGridLoad = () => {
        reportsGridLoadInflightRef.current += 1;
        setIsReportsGridLoading(true);
    };

    const endReportsGridLoad = () => {
        reportsGridLoadInflightRef.current = Math.max(0, reportsGridLoadInflightRef.current - 1);
        if (reportsGridLoadInflightRef.current === 0) {
            setIsReportsGridLoading(false);
        }
    };

    const fetchReportsData = async (tabName, overrideUserId, filterOverride, showLoader = true) => {
        const requestId = reportsFetchIdRef.current + 1;
        reportsFetchIdRef.current = requestId;
        if (showLoader) beginReportsGridLoad();
        try {

            setActiveTab(tabName)
            if (tabName === "advanceSearch") {
                tabName = "All"
                setRowDatanew([]);
                setActiveTab("All")
            }
            //  
            clearReportPreview();
            console.log(viewReportData, "viewReportData at fetchReportsData")
            if (showAdvanceSearch) {
                setShowAdvanceSearch(false)
            }

            // If a userId override is supplied (e.g. right after switching the family
            // dropdown, when viewReportData state hasn't been flushed yet), use it so
            // the API request always carries the latest user.
            const effectiveUserId =
                overrideUserId ||
                props.selectedFamilyMember?.user_id ||
                viewReportData.user_id ||
                userId;

            const requestPayload = {
                ...viewReportData,
                ...(filterOverride || {}),
                user_id: effectiveUserId,
                token: token,
                IncludeArchived: false
            };

            const response = await dispatch(getMRSitesReports(requestPayload));
            if (requestId !== reportsFetchIdRef.current) return;
            const fetchedData = response.payload?.Table || [];
            console.log(fetchedData, "fetchedData at fetchReportsData")
            let reportData = []
            setCheckedReports({})
            setCheckedReportIds([])
            // rowDatanew drives the tab counts, so it has to be emptied too when a
            // request comes back with nothing — otherwise the previous counts stick.
            if (fetchedData.length === 0) {
                setRowData([]);
                setRowDatanew([]);
            }

            if (fetchedData.length > 0 && fetchedData !== null && fetchedData !== undefined) {


                if (tabName === 'All') {
                    reportData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,

                    }));

                    const uniqueReports = getUniqueReports(reportData);

                    setRowData(uniqueReports);
                    setRowDatanew(uniqueReports);

                } else {

                    const filteredData = fetchedData.filter(report => report.group_name === tabName);
                    reportData = filteredData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,
                    }));

                    const uniqueReports = getUniqueReports(reportData);
                    setRowData(uniqueReports);
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,
                    }));
                    const uniqueReportsnew = getUniqueReports(formattedDatanew);
                    setRowDatanew(uniqueReportsnew);

                }
            }
            if (tabName === "Blood work") {
                setIsSelectedBloodWork(true);
            } else {
                setIsSelectedBloodWork(false);
            }

        } catch (error) {
            console.error("Error in fetchReportsData:", error);
        } finally {
            if (showLoader) endReportsGridLoad();
        }
    }
    const fetchArchivedReportsData = (tabName, overrideUserId, filterOverride, showLoader = true) => {
        setActiveTab(tabName)
        clearReportPreview();

        // If a userId override is supplied (e.g. right after switching the family
        // dropdown, when viewReportDataforArchived state hasn't been flushed yet),
        // use it so the API request always carries the latest user.
        const effectiveUserId =
            overrideUserId ||
            props.selectedFamilyMember?.user_id ||
            viewReportDataforArchived.user_id ||
            userId;

        const archivedRequestPayload = {
            ...viewReportDataforArchived,
            ...(filterOverride || {}),
            user_id: effectiveUserId,
            token: token,
            IncludeArchived: true
        };

        if (showLoader) beginReportsGridLoad();

        dispatch(getMRSitesReports(archivedRequestPayload)).then((resp) => {
            console.log(archivedRequestPayload, "viewReportDataforArchived at fetchArchivedReportsData")
            if (showAdvanceSearch) {
                setShowAdvanceSearch(false)
            }

            if (resp.payload.length === 0 || resp.payload === null || resp.payload === undefined) {
                setRowData([]);
                setRowDatanew([]);
            }
            else {

                const fetchedData = resp.payload.Table;
                let reportData = []

                if (tabName === 'All') {
                    reportData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,
                    }));

                    const uniqueReports = getUniqueReports(reportData);

                    setRowData(uniqueReports);
                    setRowDatanew(uniqueReports);

                } else {

                    const filteredData = fetchedData.filter(report => report.group_name === tabName);
                    reportData = filteredData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,
                    }));

                    const uniqueReports = getUniqueReports(reportData);
                    setRowData(uniqueReports);
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id,
                        is_archived: report.is_archived,
                        provider_name: report.provider_name,
                        isNewattached: report.isNewattached,
                        isHighlight: report.isHighlight,
                        edit_report_name: report.edit_report_name,
                    }));
                    const uniqueReportsnew = getUniqueReports(formattedDatanew);
                    setRowDatanew(uniqueReportsnew);

                }
            }
        }).catch((err) => {
            console.error("Error in fetchArchivedReportsData:", err);
            setRowData([]);
            setRowDatanew([]);
        }).finally(() => {
            if (showLoader) endReportsGridLoad();
        });

    }
    const uploadFromMyComputer = (e) => {
        console.log(e, "for upload from computer")
    }
    // Effect to handle row selection after data is loaded
    useEffect(() => {
        if (selectedReportID && rowData.length > 0) {
            const rowIndex = rowData.findIndex(item => item.reportId === selectedReportID);
            if (rowIndex !== -1) {
                setSelectedRow(rowIndex);
            }
        }
    }, [rowData, selectedReportID]);

    useEffect(() => {
        if (props.selectedFamilyMember) {
            const newUserId = props.selectedFamilyMember.user_id;

            // Update userId when family member changes
            setUserId(newUserId);

            // Reset states when switching family members
            setRowData([]);
            setRowDatanew([]);
            setPDFURL(null);
            setSelectedReport(null);
            setSelectedReportName(null);
            setSelectedReportID(null);
            setCheckedReports({});
            setCheckedReportIds([]);
            setMedications([]);
            setMedicationData([]);
            setLabResults([]);
            setVitalsValues({
                BloodPressure: "",
                HeartRate: "",
                BloodSugar: "",
                Weight: "",
                WaistSize: "",
            });
            setVitalsRaw([]);
            setCalendarReports([]);

            // Always reset Include Archived to OFF when switching to a different family member
            // so the new user starts on the regular (non-archived) reports view.
            setIncludeArchivedforReports(false);

            // Update view report data with new user ID (regular + archived variants).
            // Force IncludeArchived=false on the regular payload to match the reset above.
            setViewReportData(prev => ({
                ...prev,
                user_id: newUserId,
                token: token,
                IncludeArchived: false
            }));

            setViewReportDataforArchived(prev => ({
                ...prev,
                user_id: newUserId,
                token: token,
                IncludeArchived: true
            }));

            // Update log user menu analytics data
            setLogUserMenuAnalyticsData(prev => ({
                ...prev,
                UserID: newUserId
            }));

            // Update delete and archive params
            setDeleteparams(prev => ({
                ...prev,
                UserID: newUserId,
                LoginUserID: newUserId
            }));

            setArchiveparams(prev => ({
                ...prev,
                UserID: newUserId,
                LoginUserID: newUserId
            }));

            // Fetch fresh data for the selected family member
            if (props.activeMenuItem.showDashBoard) {
                // Fetch medications and repopulate the widget for the newly selected member.
                setMedicationLoading(true);
                dispatch(getMedicationatDashboard({
                    token: token,
                    user_id: newUserId
                })).then((response) => {
                    const rawData = response.payload?.Table || [];
                    if (Array.isArray(rawData)) {
                        const formattedData = rawData.map((medication) => ({
                            MedicationName: medication.medication_name || medication.Medication || '',
                            Dose: medication.medication_dose || medication.dose || '',
                            MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                            MedicationStartedFrom: medication.medication_started_from || medication.startedFrom
                                ? new Date(medication.medication_started_from || medication.startedFrom)
                                : "",
                            MedicationComments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                            Status: medication.medication_status || medication.Status || '',
                            MedicationID: medication.medication_id || medication.MedicationID || medication.id || 0,
                            medication: medication.medication_name || medication.Medication || '',
                            dose: medication.medication_dose || medication.dose || '',
                            frequency: medication.medication_recurrence || medication.frequency || '',
                            startedFrom: medication.medication_started_from || medication.startedFrom || '',
                            comments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                            status: medication.medication_status || medication.Status || ''
                        }));
                        setMedicationData(formattedData);
                        setMedications(formattedData);
                    }
                }).catch(error => {
                    console.error("Error fetching medications:", error);
                }).finally(() => {
                    setMedicationLoading(false);
                });

                // Fetch lab results and repopulate the widget for the newly selected member.
                setLabResultsLoading(true);
                dispatch(getLabResultatDashboard({
                    token: token,
                    user_id: newUserId
                })).then((response) => {
                    if (response.payload !== undefined) {
                        const labResultData = response.payload;
                        const formattedData = labResultData.map(labResult => ({
                            name: labResult.report_name,
                            date: labResult.report_date,
                            category: labResult.group_name,
                            group_name: labResult.group_name,
                            clinic: labResult.hospital_name,
                            url: labResult.report_path,
                            reportId: labResult.report_id,
                            group_id: labResult.group_id,
                            provider_name: labResult.provider_name,
                            edit_report_name: labResult.edit_report_name
                        }));
                        setLabResults(formattedData);
                    }
                }).finally(() => {
                    setLabResultsLoading(false);
                });

                // All categories for calendar provider notes
                refreshCalendarReports(newUserId);

                // Vitals / metabolics chips on the calendar read vitalsRaw.
                refreshVitalsData(newUserId);
            }

            // Reports view always loads non-archived data on family-member switch.
            // Pass newUserId explicitly because setViewReportData above is async and
            // viewReportData inside fetchReportsData would otherwise still be stale.
            if (props.activeMenuItem.showReports) {
                fetchReportsData(activeTab, newUserId);
            }
        }
        // Intentionally depends only on the selected family member's stable identity (user_id),
        // NOT the object reference. The parent recreates the selectedFamilyMember object on every
        // render (e.g. after a vitals/metabolics save dispatches to Redux), and keying off the
        // object would re-run this effect and reload Lab Results even though the member is unchanged.
        // It also previously depended on props.onRowClickforLabResults (an inline function), which
        // caused the same flicker. Row-click behavior is handled directly on the grid instead.
    }, [props.selectedFamilyMember?.user_id]);

    // Effect to handle refetch after clearing advance search
    useEffect(() => {
        console.log(props.activeMenuItem.showDashBoard, "props.activeMenuItem.showDashBoard")
        if (props.activeMenuItem.showDashBoard || !props.activeMenuItem.showReports) {
            setShowAdvanceSearch(false)
            setShowBlink(false)
            setViewReportData(prevData => ({
                ...prevData,
                ReportGroupName: "",
                ProviderName: "",
                HospitalName: "",
                SearchKey: "",
                ReportDateStart: null,
                ReportDateEnd: null,
                token: token,
                IncludeArchived: includeArchivedforReports
            }))

            // Also reset the archived version
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ReportGroupName: "",
                ProviderName: "",
                HospitalName: "",
                SearchKey: "",
                ReportDateStart: null,
                ReportDateEnd: null,
                token: token,
                IncludeArchived: true
            }))

        }
        if (shouldRefetchAfterClear) {
            setShouldRefetchAfterClear(false); // Reset the flag
            setCategoryAdvanceSearch([])
            setGroupsLst([])

            // Trigger the appropriate fetch function
            if (includeArchivedforReports) {
                fetchArchivedReportsData(activeTab);
            } else {
                fetchReportsData(activeTab);
            }
        }
    }, [shouldRefetchAfterClear, includeArchivedforReports, activeTab, props.activeMenuItem.showDashBoard, props.activeMenuItem.showReports, token]);

    const getChatHistoryCount = () => {

        dispatch(getChatHistory(params)).then((resp) => {
            // console.log(resp.payload.messages, "for chat history count")
            if (resp.payload.messages !== null && resp.payload.messages !== undefined && resp.payload.messages.length > 0) {
                const providerMessages = resp.payload.messages.filter(item => item.sender_id !== userId);
                // console.log(providerMessages, "providerMessages")
                const count = providerMessages.filter(item => item.isread === false).length;
                setChatNotificationCount(count)
                setShowChatNotification(true)

            } else {
                // Handle empty or invalid response
                setChatNotificationCount(0)
                setShowChatNotification(true)

            }
        }).catch(error => {
            console.error('Error fetching chat history:', error);
            // Handle error state
            setChatData([])
            setChatHistory([])
        })


    }


    useEffect(() => {
        setPDFURL(null)
        setIncludeArchivedforReports(false)

        getChatHistoryCount();

        setInterval(() => {
            getChatHistoryCount();
        }, 2000);

        // // Set up timer to call getChatHistoryCount every 2 seconds
        // const intervalId = setInterval(() => {
        //     getChatHistoryCount();
        // }, 2000);

        // // Cleanup interval on component unmount
        // return () => clearInterval(intervalId);

        if (props.isFromReports) {
            setActiveTab('All');
            fetchReportsData('All');
        } else if (isProvider && Number(props.activeTab?.parent_id) !== 2) {
            fetchReportsData(props.activeTab?.title !== undefined ? props.activeTab.title : activeTab)
        }


        dispatch(getgridHeaders(params)).then((response) => {
            setGridHeaers(response.payload || []);
            const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
                name: report.name,
                id: report.id
            }));
            const formattedDataforGroupList = (response.payload || []).map(report => ({
                category: report.name,
                id: report.id
            }));
            setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
            setGroupsLst(formattedDataforGroupList);

        });

        dispatch(getLogUserMenuAnalytics(logUserMenuAnalyticsData)).then((response) => {
            console.log("Response from getLogUserMenuAnalytics:", response + logUserMenuAnalyticsData);
        });

        setMedicationLoading(true);
        dispatch(getMedicationatDashboard({
            token: token,
            user_id: userId
        })).then((response) => {

            const rawData = response.payload?.Table || [];


            if (!Array.isArray(rawData)) {
                console.error("Expected medication data to be an array but got:", rawData);
                return;
            }

            const formattedData = rawData.map((medication) => ({
                MedicationName: medication.medication_name || medication.Medication || '',
                Dose: medication.medication_dose || medication.dose || '',
                MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                MedicationStartedFrom: medication.medication_started_from || medication.startedFrom
                    ? new Date(medication.medication_started_from || medication.startedFrom)
                    : "",
                MedicationComments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                Status: medication.medication_status || medication.Status || '',
                // Add MedicationID for delete operations
                MedicationID: medication.medication_id || medication.MedicationID || medication.id || 0,

                medication: medication.medication_name || medication.Medication || '',
                dose: medication.medication_dose || medication.dose || '',
                frequency: medication.medication_recurrence || medication.frequency || '',
                startedFrom: medication.medication_started_from || medication.startedFrom || '',
                comments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                status: medication.medication_status || medication.Status || ''
            }));
            console.log(formattedData, "formattedData1")
            setMedicationData(formattedData);
        }).catch(error => {
            console.error("Error fetching medications:", error);
        }).finally(() => {
            setMedicationLoading(false);
        });
        const labdata = {
            user_id: userId,
            token: token
        }

        // Only fetch Lab Results the first time this effect runs for the current mount.
        // Re-runs caused by unrelated functionality changes (activeTab, analytics, etc.)
        // must not reload Lab Results. Explicit refresh paths handle their own re-fetch.
        if (!dashboardLabResultsLoadedRef.current) {
            dashboardLabResultsLoadedRef.current = true;

            setLabResultsLoading(true);
            dispatch(getLabResultatDashboard(labdata)).then((response) => {

                if (response.payload !== undefined) {
                    const labResultData = response.payload;
                    console.log(labResultData, "labResultData")


                    const formattedData = labResultData.map(labResult => ({
                        name: labResult.report_name,
                        date: labResult.report_date,
                        category: labResult.group_name,
                        group_name: labResult.group_name,
                        clinic: labResult.hospital_name,
                        url: labResult.report_path,
                        reportId: labResult.report_id,
                        group_id: labResult.group_id,
                        provider_name: labResult.provider_name,
                        edit_report_name: labResult.edit_report_name


                    }));
                    setLabResults(formattedData);
                }

            }).finally(() => {
                setLabResultsLoading(false);
            });

            // All report categories for HealthCare Calendar provider notes
            refreshCalendarReports(userId);
        }

        dispatch(getVitals(labdata)).then((response) => {
            const vitalsData = response.payload || [];
            console.log(vitalsData, "vitalsData")
            setVitalsRaw(Array.isArray(vitalsData) ? vitalsData : []);
            const systolicData = [];
            const diastolicData = [];
            const heartRateData = [];
            const bloodSugarData = [];
            const weightData = [];
            const waistSizeData = [];

            vitalsData.forEach(vital => {
                if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                    systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                    diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                }
                if (vital.LastUpdated && vital.HeartRate) {
                    heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                }
                if (vital.LastUpdated && vital.BloodSugar) {
                    bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                }
                if (vital.LastUpdated && vital.Weight) {
                    weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                }
                if (vital.LastUpdated && vital.WaistSize) {
                    waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                }
            });

            setSeriesData([
                { name: 'Systolic', data: systolicData },
                { name: 'Diastolic', data: diastolicData },
            ]);
            setHeartRateData([
                { name: 'Heart Rate', data: heartRateData },
            ]);
            setBloodSugarData([
                { name: 'Blood Sugar', data: bloodSugarData },
            ]);
            setWeightData([
                { name: 'Weight', data: weightData },
            ]);
            setWaistSizeData([
                { name: 'Waist Size', data: waistSizeData },
            ]);

            const latestVital = vitalsData[vitalsData.length - 1] || {};
            setVitalsValues({
                BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                    ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                    : "0",
                HeartRate: latestVital.HeartRate || "0",
                BloodSugar: latestVital.BloodSugar || "0",
                Weight: latestVital.Weight || "0",
                WaistSize: latestVital.WaistSize || "0",
            });
        });

        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            console.log("Cleaning up fullscreen listener.");
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, [dispatch, token, logUserMenuAnalyticsData, props.isFromDetails, props.isFromReports]);

    const menuCategoryTitle = props.activeTab && Number(props.activeTab.parent_id) === 2
        ? (props.activeTab.title || props.activeTab.name || '')
        : '';
    const appliedMenuCategoryRef = useRef('');
    useEffect(() => {
        if (!menuCategoryTitle || appliedMenuCategoryRef.current === menuCategoryTitle) return;
        appliedMenuCategoryRef.current = menuCategoryTitle;
        setGridData({ name: menuCategoryTitle });
    }, [menuCategoryTitle]);



    const onAdvanceSearch = () => {
        setShowAdvanceSearch(true);
        const panel = document.querySelector('.advanceSearchcontainer');
        if (panel) {
            panel.style.transition = 'transform 0.3s ease-in-out';
            panel.style.transform = 'translateX(0)';
        }
        dispatch(getgridHeaders(params)).then((response) => {
            setGridHeaers(response.payload || []);
            const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
                name: report.name,
                id: report.id
            }));

            setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
            // setGroupsLst(formattedDataforGroupList);

        });
        dispatch(getProviderforAdvanceSearch({
            ...viewReportData,
            token: token
        }))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "provider");
                const mappedProviders = resp.Table.map(provider => ({
                    id: 0,
                    name: provider.provider_name || provider.name
                }));
                setProvider(mappedProviders);
            })
            .catch((error) => {
                console.error("Error fetching provider data:", error);
            });

        dispatch(getHospitalsforAdvanceSearch({
            ...viewReportData,
            token: token
        }))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "Hospitals");
                const mappedHospitals = resp.Table.map(hospital => ({
                    id: 0,
                    name: hospital.hospital_name || hospital.name
                }));
                setHospital(mappedHospitals);
            })
            .catch((error) => {
                console.error("Error fetching hospital data:", error);
            });
    };
    const handleCategoryChange = (selected) => {
        setSelectedCategories(selected);
        console.log(selected, "selected for advance search")

        // Handle both array and null/undefined cases
        if (!selected || !Array.isArray(selected)) {
            setReportGroupNames('');
            setViewReportData(prevData => ({
                ...prevData,
                ReportGroupName: ''
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ReportGroupName: ''
            }));
            return;
        }

        const selectedValues = selected.map(item => item.value).filter(value => value !== undefined);
        const selectedIdsString = selectedValues.join(',');
        setReportGroupNames(selectedIdsString);
        console.log(selectedIdsString, "reportGroupNames")
        console.log(selected, "selected")
        setViewReportData(prevData => ({
            ...prevData,
            ReportGroupName: selectedIdsString
        }));
        setViewReportDataforArchived(prevData => ({
            ...prevData,
            ReportGroupName: selectedIdsString
        }));
        console.log(viewReportData, "viewReportData for advance search")
    };

    const handleProviderChange = (selected) => {
        console.log('handleProviderChange called with:', selected);
        setSelectedProviders(selected);

        // Handle both array and null/undefined cases
        if (!selected || !Array.isArray(selected)) {
            setViewReportData(prevData => ({
                ...prevData,
                ProviderName: ''
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ProviderName: ''
            }));
            return;
        }

        const selectedProviderIds = selected.map(item => item.label).filter(value => value !== undefined).join(',');
        console.log('Selected provider IDs:', selectedProviderIds);
        setViewReportData(prevData => ({
            ...prevData,
            ProviderName: selectedProviderIds
        }));
        setViewReportDataforArchived(prevData => ({
            ...prevData,
            ProviderName: selectedProviderIds
        }));
    };

    const handleHospitalChange = (selected) => {
        console.log('handleHospitalChange called with:', selected);
        setSelectedHospitals(selected);

        // Handle both array and null/undefined cases
        if (!selected || !Array.isArray(selected)) {
            setViewReportData(prevData => ({
                ...prevData,
                HospitalName: ''
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                HospitalName: ''
            }));
            return;
        }

        const selectedHospitalIds = selected.map(item => item.label).filter(value => value !== undefined).join(',');
        console.log('Selected hospital IDs:', selectedHospitalIds);
        setViewReportData(prevData => ({
            ...prevData,
            HospitalName: selectedHospitalIds
        }));
        setViewReportDataforArchived(prevData => ({
            ...prevData,
            HospitalName: selectedHospitalIds
        }));
    };
    const onDateChange = (selectedDates) => {
        console.log('Selected dates:', selectedDates);

        if (selectedDates && selectedDates.length >= 2) {
            const startDate = selectedDates[0];
            const endDate = selectedDates[1];

            // Format dates to MM/DD/YYYY format for API (convert from Y-m-d to m/d/Y)
            const formatDateForAPI = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${month}/${day}/${year}`;
            };

            const formattedStartDate = formatDateForAPI(startDate);
            const formattedEndDate = formatDateForAPI(endDate);

            console.log('Formatted dates for API - Start:', formattedStartDate, 'End:', formattedEndDate);

            setStartDate(startDate);
            setEndDate(endDate);

            setViewReportData(prevData => ({
                ...prevData,
                ReportDateStart: formattedStartDate,
                ReportDateEnd: formattedEndDate
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ReportDateStart: formattedStartDate,
                ReportDateEnd: formattedEndDate
            }));
        } else if (selectedDates && selectedDates.length === 1) {
            // If only one date is selected, set both start and end to the same date
            const singleDate = selectedDates[0];

            const formatDateForAPI = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${month}/${day}/${year}`;
            };

            const formattedDate = formatDateForAPI(singleDate);

            setStartDate(singleDate);
            setEndDate(singleDate);

            setViewReportData(prevData => ({
                ...prevData,
                ReportDateStart: formattedDate,
                ReportDateEnd: formattedDate
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ReportDateStart: formattedDate,
                ReportDateEnd: formattedDate
            }));
        } else {
            // If no dates selected, clear the date filters
            console.log('Clearing date filters');
            setStartDate(null);
            setEndDate(null);

            setViewReportData(prevData => ({
                ...prevData,
                ReportDateStart: null,
                ReportDateEnd: null
            }));
            setViewReportDataforArchived(prevData => ({
                ...prevData,
                ReportDateStart: null,
                ReportDateEnd: null
            }));
        }
    };


    const onApplySearch = () => {

        setShowBlink(true);

        if (includeArchivedforReports) {
            fetchArchivedReportsData(activeTab)

        } else {

            fetchReportsData("advanceSearch");
        }


    }

    const onClearAdvanceSearch = () => {
        setShowBlink(false);
        setReportGroupNames("")
        setSelectedCategories([]);
        setSelectedProviders([]);
        setSelectedHospitals([]);
        setSearchQuery("");
        //  setShowAdvanceSearch(false);
        setStartDate(null);
        setEndDate(null);
        setRowDatanew([])
        setRowData([])


        const updatedViewReportData = {
            ReportGroupName: "",
            ProviderName: "",
            user_id: userId,
            HospitalName: "",
            SearchKey: "",
            ReportDateStart: null,
            ReportDateEnd: null,
            token: token,
            IncludeArchived: false
        };

        const updatedViewReportDataforArchived = {
            ReportGroupName: "",
            ProviderName: "",
            user_id: userId,
            HospitalName: "",
            SearchKey: "",
            ReportDateStart: null,
            ReportDateEnd: null,
            token: token,
            IncludeArchived: true
        };

        // Update both state objects
        setViewReportData(updatedViewReportData);
        setViewReportDataforArchived(updatedViewReportDataforArchived);

        // Set flag to trigger refetch in useEffect
        setShouldRefetchAfterClear(true);

        console.log(updatedViewReportData, "updatedViewReportData for advance search")
    }



    const onFullScreenToggle = () => {
        const elem = previewContainerRef.current;
        if (!elem) {
            return;
        }

        if (!document.fullscreenElement) {
            elem.requestFullscreen()
                .then(() => { })
                .catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
                    .then(() => { })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                    });
            } else {
                console.error("Exit fullscreen is not supported by this browser.");
            }
        }
    };

    const [draggedWidget, setDraggedWidget] = useState(null);
    const [widgetPositions, setWidgetPositions] = useState({
        medications: { order: 0, col: 'col-12 col-md-6 col-xs-6 col-lg-3' },
        labResults: { order: 1, col: 'col-12 col-md-6 col-xs-6 col-lg-3' },
        vitals: { order: 2, col: 'col-12 col-md-sm-12 col-xs-12 col-lg-6' }
    });

    const handleWidgetDragStart = (e, widgetType) => {
        e.dataTransfer.setData("widgetType", widgetType);
        setDraggedWidget(widgetType);
        e.currentTarget.style.opacity = "0.5";
    };

    const handleWidgetDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "2px dashed var(--pmr-secondary)";
    };

    const handleWidgetDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
    };

    const handleWidgetDrop = (e, targetWidgetType) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
        e.currentTarget.style.opacity = "1";

        if (draggedWidget && draggedWidget !== targetWidgetType) {
            const draggedPos = widgetPositions[draggedWidget];
            const targetPos = widgetPositions[targetWidgetType];

            setWidgetPositions(prev => ({
                ...prev,
                [draggedWidget]: { ...prev[draggedWidget], order: targetPos.order },
                [targetWidgetType]: { ...prev[targetWidgetType], order: draggedPos.order }
            }));
        }

        setDraggedWidget(null);
    };

    const handleWidgetDragEnd = (e) => {
        e.currentTarget.style.opacity = "1";
    };

    const getSortedWidgets = () => {
        const allWidgets = Object.entries(widgetPositions)
            .sort(([, a], [, b]) => a.order - b.order)
            .map(([type]) => type);

        if (isAccess) {
            return allWidgets.filter(widget =>
                ['medications', 'labResults', 'vitals'].includes(widget)
            );
        }

        return allWidgets;
    };

    // Add polling effect for chat history
    useEffect(() => {
        let pollInterval;

        // if (showLiveChat) {
        //     // Initial call
        //     invokeChatHistory();

        //     // Set up polling every 5 seconds
        //     pollInterval = setInterval(() => {
        //         invokeChatHistory();
        //     }, 5000); // 5 seconds
        // }

        // Cleanup interval on unmount or when showLiveChat changes
        return () => {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [showLiveChat]); // Only re-run when showLiveChat changes

    // Cleanup speech recognition on component unmount
    useEffect(() => {
        return () => {
            if (recognitionRef.current) {
                recognitionRef.current.stop();
            }
        };
    }, []);

    // Reset advance search when showReports becomes false
    useEffect(() => {
        if (props.activeMenuItem.showReports) {
            // Reset advance search filters and close advance search panel when showReports is false
            setSelectedCategories([]);
            setSelectedProviders([]);
            setSelectedHospitals([]);
            setShowAdvanceSearch(false);
            setStartDate(null);
            setEndDate(null);
            setSearchQuery("");
            setReportGroupNames("");
            setShowBlink(false);
            setCheckedReports({})
            setCheckedReportIds([])
        }
    }, [props.activeMenuItem.showReports]);

    // Add keyboard shortcut for voice recognition
    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check for Ctrl+Shift+V (Windows/Linux) or Cmd+Shift+V (Mac)
            if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'V') {
                event.preventDefault();
                if (showLiveChat && !isRecording) {
                    startSpeechRecognitionwhileChat();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showLiveChat, isRecording]);

    // Handle file selection from computer
    const handleFileSelect = (file) => {
        if (file) {
            setSelectedFile(file);
            // Create file URL for preview
            const fileUrl = URL.createObjectURL(file);

            // Add to uploaded files
            const newFile = {
                id: Date.now(),
                name: file.name,
                size: file.size,
                type: file.type,
                url: fileUrl,
                file: file,
                uploadDate: new Date().toISOString()
            };

            setUploadedFiles(prev => [...prev, newFile]);

            // Update chat message with file name
            setNewMessage(file.name);

            // Show preview based on file type
            if (file.type.startsWith('image/')) {
                setImagePreviewUrl(fileUrl);
                setPdfPreviewUrl(null);
            } else if (file.type === 'application/pdf' || file.type.includes('document')) {
                setPdfPreviewUrl(fileUrl);
                setImagePreviewUrl(null);
            }

            // Log file details
            console.log('File selected:', {
                name: file.name,
                size: file.size,
                type: file.type,
                url: fileUrl
            });
        }
    };

    // Handle file upload from computer
    const handleUploadFromComputer = (e) => {
        e.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear previous selection
            fileInputRef.current.click();
        }
    };

    // Handle file input change
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            handleFileSelect(file);
        }
    };

    // Function to get file preview URL
    const getFilePreviewUrl = (file) => {
        if (!file) return null;
        return URL.createObjectURL(file);
    };

    // Function to clear selected file
    const clearSelectedFile = () => {
        setSelectedFile(null);
        setNewMessage('');
        setImagePreviewUrl(null);
        setPdfPreviewUrl(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const refreshMedications = async () => {
        setMedicationLoading(true);
        await dispatch(getMedicationatDashboard({
            token: token,
            user_id: userId
        })).then((response) => {
            const rawData = response.payload?.Table || [];
            const formattedData = rawData.map((medication) => ({
                MedicationName: medication.medication_name || medication.Medication || '',
                Dose: medication.medication_dose || medication.dose || '',
                MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                MedicationStartedFrom: medication.medication_started_from || medication.startedFrom || '',
                MedicationComments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                Status: medication.medication_status || medication.Status || '',
                // Add MedicationID for delete operations
                MedicationID: medication.medication_id || medication.MedicationID || medication.id || 0,
                medication: medication.medication_name || medication.Medication || '',
                dose: medication.medication_dose || medication.dose || '',
                frequency: medication.medication_recurrence || medication.frequency || '',
                startedFrom: medication.medication_started_from || medication.startedFrom || '',
                comments: medication.MedicationComments || medication.medication_comments || medication.comments || '',
                status: medication.medication_status || medication.Status || ''
            }));
            setMedicationData(formattedData);
            setMedications(formattedData);
        }).finally(() => {
            setMedicationLoading(false);
        });
    };

    return (
        <>

            <div style={{ backgroundColor: "#fffff" }}>
                <div className={`container-fluid ${props.activeMenuItem?.showAskAcme ? 'ask-acme-host-wrap' : 'mt-5'}`}>

                    {/* Patient Details View - Similar to Provider's isProviderReports */}
                    {isPatientDetailsView && (
                        <div>
                            <UserLandingPage
                                activeMenuItem={props.activeMenuItem}
                                activeTab={props.activeTab}
                                onViewReportsClick={props.onViewReportsClick}
                                isFromProviderDashboard={false}
                                userID={localStorage.getItem('patientUserId')}
                                patientName={selectedPatientName}
                                onBack={handleBackToSharedReports}
                                isFromDetails={isFromDetails}
                                isFromReports={isFromReports}
                            />
                        </div>
                    )}

                    {/* Regular User Content - only show when not in patient details view */}
                    {!isPatientDetailsView && (
                        <>
                            {/* Show announcement banner only on dashboard */}
                            {(props.activeMenuItem.showDashBoard) && (
                                <ApplicationAnnouncement />
                            )}

                            {(props.activeMenuItem.showDashBoard) && (
                                <div className="row d-flex justify-content-between align-items-center p-0">
                                    <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 px-4">
                                        {(!isProvider && !isAccess) && (
                                            <span>
                                                Have a report(s) to upload?&nbsp;
                                                <a
                                                    href="#"
                                                    style={{ color: "var(--pmr-danger)", textDecoration: "underline", fontWeight: "bold" }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setShowUploadModal(true);
                                                    }}
                                                >
                                                    Click here
                                                </a>
                                            </span>
                                        )}

                                        {isProvider && (

                                            <BackButton onBack={props.onBack} patientName={props.patientName} />

                                        )}
                                    </div>

                                    {(!isProvider || props.isFromDetails) && (
                                        <>

                                            <div className="text-start mt-4 col-md-8 col-lg-8 col-sm-8 col-xs-8 d-flex justify-content-start align-items-center gap-4 iconMargin p-0">
                                                <div className="menu-row">
                                                    {menuItems.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="menu-card"
                                                            onClick={() => setLogUserMenuAnalytics(item, false)}
                                                        >
                                                            <span className="menu-icon-bg">
                                                                {item.icon}
                                                            </span>
                                                            <p className="menu-label">{item.label}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="row g-3 mb-3 hc-dashboard-row align-items-stretch">
                                                <div className="col-12 col-lg-6 d-flex">
                                                    <div className="shadow-lg py-2 rounded-3 hc-calendar-shell w-100 h-100 d-flex flex-column">
                                                        <Scheduler
                                                            token={token}
                                                            userId={userId}
                                                            medications={medications}
                                                            vitals={vitalsRaw}
                                                            reports={calendarReports}
                                                            onNavigateToReports={handleCalendarDateToReports}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 d-flex">
                                                    <div className="hc-side-panel w-100 h-100 d-flex flex-column gap-3">
                                                        {/* Medications + Lab Results — horizontal */}
                                                        <div className="row g-2 m-0 flex-shrink-0">
                                                            <div className="col-6 ps-0 pe-1">
                                                                <div className="card shadow-lg p-0 hc-side-card h-100">
                                                                    <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG py-2">
                                                                        <h6 className="mb-0 text-capitalize">Medications</h6>
                                                                    </div>
                                                                    <div className="card-body p-0">
                                                                        <CTGrid
                                                                            rowData={medications}
                                                                            columnDefs={medColumns}
                                                                            loading={medicationLoading}
                                                                            onAddEditable={!isAccess ? "Add/Edit Medications" : undefined}
                                                                            onAddEdit={!isAccess}
                                                                            label={!isAccess ? "Add/Edit" : undefined}
                                                                            height={185}
                                                                            disablePagination={true}
                                                                            suppressHorizontalScroll={true}
                                                                        />
                                                                    </div>
                                                                    {!isProvider && !isAccess && (
                                                                        <div className="card-footer text-start d-flex px-3 py-2" style={{ backgroundColor: 'white' }}>
                                                                            <span className="modalfooterclickeventtext cursor-pointer" onClick={handleAddClick}>Add</span>
                                                                            <span className="mx-2 text-muted">|</span>
                                                                            <span className="modalfooterclickeventtext cursor-pointer" onClick={handleEditClick}>Edit</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-6 pe-0 ps-1">
                                                                <div className="card shadow-lg p-0 hc-side-card h-100">
                                                                    <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG py-2">
                                                                        <h6 className="mb-0 text-capitalize">Lab Results</h6>
                                                                    </div>
                                                                    <div className="card-body p-0">
                                                                        <CTGrid
                                                                            rowData={labResults}
                                                                            columnDefs={labColumns}
                                                                            height={185}
                                                                            loading={labResultsLoading}
                                                                            onRowClickforLabResults={(event) => setLogUserMenuAnalytics(event, true)}
                                                                            disablePagination={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Vitals — fills remaining height so bottoms align */}
                                                        <div className="card shadow-lg p-0 hc-side-card hc-side-vitals flex-grow-1 d-flex flex-column">
                                                            <AddVitals
                                                                header="Vitals"
                                                                title="Blood Pressure"
                                                                height={160}
                                                                seriesData={seriesData}
                                                                BloodPressure={vitalsValues.BloodPressure}
                                                                heartRate={vitalsValues.HeartRate}
                                                                Bloodsugar={vitalsValues.BloodSugar}
                                                                weight={vitalsValues.Weight}
                                                                waist={vitalsValues.WaistSize}
                                                                type="area"
                                                                heartRateData={seriesDataforHeartRate}
                                                                bloodSugarData={seriesDataforBloodSugar}
                                                                waistData={seriesDataforWaistSize}
                                                                weightData={seriesDataforWeight}
                                                                onClickHandler={!isAccess ? () => handleAddVitals(vitalsValues) : undefined}
                                                                Bpheader="Blood Pressure"
                                                                heartRateheader="Heart Rate"
                                                                bloodSugarDataheader="Blood Sugar"
                                                                wieghtDataheader="Weight"
                                                                waistheader="Waist Size"
                                                                userId={userId}
                                                                selectedFamilyMember={props.selectedFamilyMember}
                                                                isFromUserLandingPage={isProvider ? false : true}
                                                                onRefresh={refreshVitalsData}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Keep widget drag-order row available below for providers / access modes that need the old strip */}
                                            <div className="row p-0 m-0 medicationContainer margin-0 d-none">
                                                {getSortedWidgets().map((widgetType) => {
                                                    if (isAccess && !['medications', 'labResults', 'vitals'].includes(widgetType)) {
                                                        return null;
                                                    }

                                                    switch (widgetType) {
                                                        case 'medications':
                                                            return (
                                                                <div
                                                                    key="medications"
                                                                    className={widgetPositions.medications.col}
                                                                    draggable={!isAccess}
                                                                    onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'medications')}
                                                                    onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                                    onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                                    onDrop={(e) => !isAccess && handleWidgetDrop(e, 'medications')}
                                                                    onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                                >
                                                                    <div className="card shadow-lg p-0" style={isProvider ? { height: '350px', minHeight: '350px', maxHeight: '350px' } : { height: '390px', minHeight: '390px', maxHeight: '390px' }}>
                                                                        <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG">
                                                                            <h6 className="mb-0 text-capitalize">Medications</h6>
                                                                        </div>
                                                                        <div className="card-body p-0">
                                                                            <CTGrid
                                                                                rowData={medications}
                                                                                columnDefs={medColumns}
                                                                                loading={medicationLoading}
                                                                                onAddEditable={!isAccess ? "Add/Edit Medications" : undefined}
                                                                                onAddEdit={!isAccess}
                                                                                label={!isAccess ? "Add/Edit" : undefined}
                                                                                height={250}
                                                                                disablePagination={true}
                                                                                suppressHorizontalScroll={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );

                                                        case 'labResults':
                                                            return (
                                                                <div
                                                                    key="labResults"
                                                                    className={widgetPositions.labResults.col}
                                                                    draggable={!isAccess}
                                                                    onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'labResults')}
                                                                    onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                                    onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                                    onDrop={(e) => !isAccess && handleWidgetDrop(e, 'labResults')}
                                                                    onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                                >
                                                                    <div className="card shadow-lg p-0" style={isProvider ? { height: '350px', minHeight: '350px', maxHeight: '350px' } : { height: '390px', minHeight: '390px', maxHeight: '390px' }}>
                                                                        <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG">
                                                                            <h6 className="mb-0 text-capitalize">Lab Results</h6>
                                                                        </div>
                                                                        <div className="card-body p-0">
                                                                            <CTGrid rowData={labResults} columnDefs={labColumns} height={isProvider ? 250 : 295} loading={labResultsLoading} onRowClickforLabResults={(event) => setLogUserMenuAnalytics(event, true)} disablePagination={true} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );

                                                        case 'vitals':
                                                            return (
                                                                <div
                                                                    key="vitals"
                                                                    className={widgetPositions.vitals.col}
                                                                    draggable={!isAccess}
                                                                    onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'vitals')}
                                                                    onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                                    onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                                    onDrop={(e) => !isAccess && handleWidgetDrop(e, 'vitals')}
                                                                    onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                                >
                                                                    <AddVitals
                                                                        header="Vitals"
                                                                        title="Blood Pressure"
                                                                        height={200}
                                                                        seriesData={seriesData}
                                                                        BloodPressure={vitalsValues.BloodPressure}
                                                                        heartRate={vitalsValues.HeartRate}
                                                                        Bloodsugar={vitalsValues.BloodSugar}
                                                                        weight={vitalsValues.Weight}
                                                                        waist={vitalsValues.WaistSize}
                                                                        type="area"
                                                                        heartRateData={seriesDataforHeartRate}
                                                                        bloodSugarData={seriesDataforBloodSugar}
                                                                        waistData={seriesDataforWaistSize}
                                                                        weightData={seriesDataforWeight}
                                                                        onClickHandler={!isAccess ? () => handleAddVitals(vitalsValues) : undefined}
                                                                        Bpheader="Blood Pressure"
                                                                        heartRateheader="Heart Rate"
                                                                        bloodSugarDataheader="Blood Sugar"
                                                                        wieghtDataheader="Weight"
                                                                        waistheader="Waist Size"
                                                                        userId={userId}
                                                                        selectedFamilyMember={props.selectedFamilyMember}
                                                                        isFromUserLandingPage={isProvider ? false : true}
                                                                        onRefresh={refreshVitalsData}
                                                                    />
                                                                </div>
                                                            );

                                                        default:
                                                            return null;
                                                    }
                                                })}
                                            </div>
                                            {!isAccess && (
                                                <div style={{ position: "relative", paddingBottom: 50 }}>
                                                    <Dashbaord userId={userId} selectedFamilyMember={props.selectedFamilyMember} onRowClickforLabResults={(event) => setLogUserMenuAnalytics(event, true)} />
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}

                            {(props.activeMenuItem.showReports || (props.isFromReports && isProvider)) && (
                                <>
                                    {isProvider && (

                                        <BackButton onBack={props.onBack} patientName={props.patientName} />
                                    )}
                                    <div>

                                        <ReportDisplaySection
                                            isProvider={isProvider}
                                            searchQuery={searchQuery}
                                            onSearchChange={(e) => onSearch(e)}
                                            onSearchClear={handleSearchClear}
                                            onAdvanceSearchClick={onAdvanceSearch}
                                            onIncludeArchivedToggle={() => includeArchived(activeTab)}
                                            onIncludeArchivedTogglewithlabel={() => includeArchived(activeTab)}
                                            onRefreshClick={() => onRefresh(activeTab)}
                                            gridHeaders={gridHeaders}
                                            activeTab={activeTab}
                                            onTabClick={(tab) => setGridData(tab)}
                                            rowDatanew={rowDatanew}
                                            gridRef={gridRef}
                                            rowData={rowData}
                                            columnDefs={columnDefs}
                                            onRowClicked={onRowClicked}
                                            previewContainerRef={previewContainerRef}
                                            isFullscreen={isFullscreen}
                                            pdfUrl={pdfUrl}
                                            contentType={contentType}
                                            isReportPreviewLoading={isReportPreviewLoading}
                                            selectedRow={selectedRow}
                                            selectedReport={selectedReport}
                                            selectedReportName={selectedReportName}
                                            selectedReportID={selectedReportID}
                                            checkedReportIds={checkedReportIds}
                                            onFullScreenToggle={onFullScreenToggle}
                                            onDeleteReport={onDelete}
                                            onArchiveReport={onArchive}
                                            onDownloadReport={handleDownload}
                                            onShareReport={handleShare}
                                            onEditReport={handleEdit}
                                            iframeRef={iframeRef}
                                            isSelectedBloodWork={isSelectedBloodWork}
                                            onUploadReport={() => setShowUploadModal(true)}
                                            handleNotes={handleNotes}
                                            onViewTrends={handleViewTrends}
                                            onCompareReports={handleCompareReports}
                                            includeArchive={includeArchivedforReports}
                                            onArchiveUndo={onArchiveUndo}
                                            selectedFamilyMember={props.selectedFamilyMember}
                                            showBlink={showBlink}
                                            onSummary={handleBloodWorkSummary}
                                            handleClear={handleClear}
                                            onEmailClick={handleEmailClick}
                                            onMultipleDownloadClick={handleMultipleDownloadClick}
                                            isReportsGridLoading={isReportsGridLoading}
                                            hideAdvancedSearchOption
                                        />
                                    </div>
                                </>
                            )}

                            {props.activeMenuItem.showSharedReports && <SharedReports handlePatientSummaryClick={handlePatientSummaryClick} handleReportIconClick={handleReportIconClick} selectedFamilyMember={props.selectedFamilyMember} />}
                            {props.activeMenuItem.showBlog && <Blog />}
                            {props.activeMenuItem.showBMI && <BMIScreen selectedFamilyMember={props.selectedFamilyMember} />}
                            {props.activeMenuItem.showReceipt && <Receipts selectedFamilyMember={props.selectedFamilyMember} />}
                            {props.activeMenuItem.showNotes && <NoteApp selectedFamilyMember={props.selectedFamilyMember} />}
                            {props.activeMenuItem.showAskAcme && (
                                <div className="ask-acme-host">
                                    <AskAcme selectedFamilyMember={props.selectedFamilyMember} />
                                </div>
                            )}
                            {props.activeMenuItem.showProfile && (
                                <>
                                    {console.log("Rendering AccountSettings component, showProfile:", props.activeMenuItem.showProfile)}
                                    <AccountSettings
                                        onViewReportsClick={props.onViewReportsClick}
                                    />
                                </>
                            )}
                            {props.activeMenuItem.showSecondOpinion && <SecondOpinion />}
                            {props.activeMenuItem.showMedicalCondition && <MedicalCondition />}
                            {props.activeMenuItem.showScheduleForChildren && <ScheduleForChildren />}
                            {props.activeMenuItem.showScheduleByAge && <ScheduleByAge />}
                            {props.activeMenuItem.showTrueContraindications && <TrueContraindications />}
                            {props.activeMenuItem.showAdministeringVaccinesToAdults && <AdministeringVaccinesToAdults />}
                            {props.activeMenuItem.showViewSharedReports && <ViewSharedReports />}

                            {showAdvanceSearch && (
                                <AdvanceSearch
                                    categoryAdvanceSearch={categoryAdvanceSearch}
                                    provider={provider}
                                    hospitals={hospitals}
                                    selectedCategories={selectedCategories}
                                    selectedProviders={selectedProviders}
                                    selectedHospitals={selectedHospitals}
                                    handleCategoryChange={handleCategoryChange}
                                    handleProviderChange={handleProviderChange}
                                    handleHospitalChange={handleHospitalChange}
                                    onApplySearch={onApplySearch}
                                    onClose={() => setShowAdvanceSearch(false)}
                                    onClearSearch={onClearAdvanceSearch}
                                    onDateChange={onDateChange}
                                    type={"range"}
                                    value={[startDate, endDate]}
                                />
                            )}
                        </>
                    )}
                </div>



                {showShareReportDialog && (
                    <ShareReportDialog
                        show={showShareReportDialog}
                        onHide={() => setShowShareReportDialog(false)}
                        reportName={selectedReportName}
                        reportId={selectedReportID}
                        reportLink={pdfUrl}
                        onShareReport={handleShare}
                        token={token}
                        userID={userId}
                    />
                )}

                {showEditReportDialog && (
                    <EditReportDialog
                        className='mt-2'
                        show={showEditReportDialog}
                        onClose={() => setShowEditReportDialog(false)}
                        initialData={data}
                        onHide={() => setShowEditReportDialog(false)}
                        reportData={reportData}
                        groupsLst={groupsLst}
                        handleInputChange={handleInputChange}
                        onSave={handleSave}
                        selectedFamilyMember={props.selectedFamilyMember}
                    />
                )}
            </div >

            <UploadReports
                show={showUploadModal}
                onHide={() => setShowUploadModal(false)}
                onUploadSuccess={() => {
                    onRefresh(activeTab);
                    refreshLabResults();
                    refreshCalendarReports();
                }}
                userId={userId}

            />

            <MedicationsModal
                show={showModal}
                onHide={handleModalClose}
                medications={medications}
                onSave={refreshMedications}
                mode={medicationModalMode}
                userId={props.selectedFamilyMember ? props.selectedFamilyMember.user_id : userId}
            />
            {showPatientSummaryDialog && (
                <PatientSummaryDialog
                    show={showPatientSummaryDialog}
                    onHide={() => setShowPatientSummaryDialog(false)}
                    summaryText={bloodWorkSummary}
                    summaryTitle={selectedReportName}
                />
            )}
            {(showLiveChat && !isProvider) && (
                <LiveChat
                    lstMsgs={chatHistory}
                    selectedFile={selectedFile}
                    newMessage={newMessage}
                    isRecording={isRecording}
                    viewHistory={invokeChatHistory}
                    endChat={handleEndChat}
                    openSettings={() => console.log('Settings clicked')}
                    hideChat={hideChatAndResetNotification}
                    //   handleReportSelected={handleReportSelected}
                    chatData={chatData}
                    setNewMessage={setNewMessagewhileChat}
                    sendMessage={sendnewMessagewhileChat}
                    startSpeechRecognition={startSpeechRecognitionwhileChat}
                    stopSpeechRecognition={stopSpeechRecognitionwhileChat}
                    // File handling props
                    uploadedFiles={uploadedFiles}
                    handleUploadFromComputer={handleUploadFromComputer}
                    handleFileUpload={handleFileUpload}
                    clearSelectedFile={clearSelectedFile}
                    fileInputRef={fileInputRef}
                    // Preview URLs
                    imagePreviewUrl={imagePreviewUrl}
                    pdfPreviewUrl={pdfPreviewUrl}
                    getFilePreviewUrl={getFilePreviewUrl}
                    onRefresh={invokeChatHistory}
                />
            )
            }
            {showMultipleEmailDialog && (
                <MultipleEmailDialog
                    show={showMultipleEmailDialog}
                    onHide={() => setShowMultipleEmailDialog(false)}
                    onSave={handleMultipleEmailSave}
                    reportName={selectedReportName}
                    report_id={selectedReportID}
                    token={token}
                    selectedReports={emailDialogSelectedReports}
                    user_id={userId}
                    from_email={userData?.email_address ?? ''}
                />
            )}
            {showNotesDialog && (
                <AddNote
                    show={showNotesDialog}
                    onHide={() => setShowNotesDialog(false)}
                    onSave={handleSaveNotes}
                    user_id={userId}
                    report_id={selectedReportID}
                    token={token}
                    reportName={selectedReportName}
                />
            )}

            {showViewTrends && (
                <ViewTrends
                    show={showViewTrends}
                    onHide={handleTrendsClose}
                    user_id={userId}
                    token={token}
                    isCompare={isCompare}
                    checkedReportIds={checkedReportIds}
                    reportsToCompare={checkedReportsForCompare}
                />
            )}
            {showBloodReportsAlert && (
                <PasswordChangeModal
                    show={showBloodReportsAlert}
                    onHide={() => setShowBloodReportsAlert(false)}
                    isCompare={true}
                    message={bloodReportsAlertMessage}
                    handleCloseModal={() => setShowBloodReportsAlert(false)}
                />
            )}
            {showDeleteSuccessModal && (
                <CustomSuccessModal
                    show={showDeleteSuccessModal}
                    onHide={() => setShowDeleteSuccessModal(false)}
                    message={alertMessage}
                    name={alertFileName}
                />
            )}
            {showArchiveSuccessModal && (
                <CustomSuccessModal
                    show={showArchiveSuccessModal}
                    onHide={() => {
                        setShowArchiveSuccessModal(false);
                        archiveModalShownRef.current = false;
                    }}
                    message="Report archived successfully."
                    name=""
                />
            )}
            {showUnarchiveSuccessModal && (
                <CustomSuccessModal
                    show={showUnarchiveSuccessModal}
                    onHide={() => {
                        setShowUnarchiveSuccessModal(false);
                        unarchiveModalShownRef.current = false;
                    }}
                    message="Report unarchived successfully."
                    name=""
                />
            )}
            {showDownloadSuccessModal && (
                <CustomSuccessModal
                    show={showDownloadSuccessModal}
                    onHide={() => {
                        setShowDownloadSuccessModal(false);
                        setDownloadAlertMessage("");
                        setDownloadAlertFileName("");
                    }}
                    message={downloadAlertMessage}
                    name={downloadAlertFileName}
                />
            )}
        </>
    )

}



export default UserLandingPage;
